import { useEffect, useState, useRef } from 'react'
import { useRouter } from 'next/router'
import styles from './index.module.css'
import { forgotpassword } from '../../../../../common/lib/forgotpassword'
import {
  login,
  resendOtp,
  userLogin,
  userVerify,
  forgetAgencyCodeUsename,
} from '../../../../../common/lib/login'
import { contactus } from '../../../../../common/lib/signup'
import ModalPopupComponent from '../../../../../common/components/ModalPopupComponent/ModalPopupComponent'
import modalCss from '../../../../../common/components/ModalPopupComponent/index.module.css'
import CountryDropdownComp from '@/components/CountryDropdown/index'
import getCountriesList from '../../../../../common/lib/getCountriesList'
import Countrystyles from '../../../../../common/components/CountryDropdown/theme9/index.module.css'
import { changepassword } from '../../../../../common/lib/changepassword'
import InvalidPassword from './InvalidPassword'
import { tokenExpiry } from '../../../../../common/lib/tokenExpiry'
import { getCityByCountry, getStateApi } from '../../../../lib/myProfile'
import { encryptData, decryptData } from '../../../../../common/lib/crypto/crypto'
import OTPInput from '@/components/otpInput'
import { VmsToolTip } from '@/components/vms-components/ToolTip/index'
import CaptchaComponent from '../../../../../common/components/captchaComp/index'
import {
  allowedCharactersRegex,
  spaceRestrict,
  passRestrict,
  isdCodeReg,
  alphanumericSpecialChars,
  emailReg,
  alphabetNameChars,
  phoneNoReg,
  aplhaNumericDash,
  alphanumericWithUnderscore,
  alphanumeric,
  validEmailRegex,
  onlyAlphabets,
  onlyNumber,
  alphanumericWithSpace,
  onlyNumbersRegex,
  alphabetsAndSpaces,
  disallowFirstSpace,
  passwordRegex,
  alphanumericWithSpecialCharNoSpace,
  noLeadingSpace,
  mobileNumberZeroRegex,
} from '../../../../../common/lib/utils/regex_cheat_sheet'
import { VmsInputText } from '@/components/vms-components/InputTextTwo/index'
import { VmsButton } from '@/components/vms-components/button/index'
import { VmsAutocompleteDropdown } from '@/components/vms-components/AutocompleteDropdown/index'
import { VmsMobileInputText } from '@/components/vms-components/MobileInputText/index'
import { VmsInputCheckbox } from '@/components/vms-components/InputCheckbox'
import cf from '../../../../../common/lib/utils/common'
import config from '../../../../../config/config.json'
import Cookies from 'js-cookie'
import dynamic from 'next/dynamic'
const IsdCodeDropdown = dynamic(() => import('@/commonComponents/IsdCodeDropdown/index'))
import IsdCodeDropdownCss from '@/commonComponents/IsdCodeDropdown/index.module.css'
import ModalCssMobile from '@/commonComponents/ModalPopupComponent/theme5mobile/index.module.css'
import Dropdown from '@/components/common/dropdown/theme10/index.js'
const errorsList = {
  firstName: {
    ERFN101: 'Please enter first name',
  },
  lastName: {
    ERLN101: 'Please enter last name',
  },
  companyName: {
    ERCN101: 'Please enter company name',
  },
  countryCode: {
    ERCC101: 'Please select the country code',
  },
  nationality: {
    ERNT101: 'Please select nationality',
  },
  city: {
    ERCT101: 'Please select city',
  },
  orgName: {
    ERORG101: 'Please select organisation type',
  },
  isdCode: {
    ERISD101: 'Please enter ISD Code',
  },
  address: {
    ERAD101: 'Please select address',
  },
  pincode: {
    ERPN101: 'Please select pincode',
  },
  mobileNo: {
    ERMN101: 'Invalid mobile number',
    ERMN102: 'Please enter mobile number',
  },
  email: {
    ERE101: 'Please enter email address',
    ERE102: 'Please enter a valid email address',
  },
  password: {
    ERP101:
      'Password must be between 8-13 characters in length and must comprise of at least 1 lowercase alphabet (a-z), 1 uppercase alphabet (A-Z), 1 number (0-9) and 1 special character',
    ERP104: 'Please enter password',
    //ERP105: 'Incorrect password. Try again',
    ERP105:
      'Password must be 8–20 characters, include an uppercase letter, a number, and a special character',
  },
  confirmPassword: {
    ERP102: 'Please re-enter new password',
    ERP103: 'Passwords do not match',
  },
  OTP: {
    EROTP101: 'Please enter OTP',
    EROTP102: 'The OTP entered is incorrect. Please try again',
    EROTP103: 'The OTP entered is incorrect. Please try again',
  },
  isTermsChecked: {
    ERTC101: 'Please accept the terms & conditions to proceed',
  },
  agency_code: {
    ERE101: 'Please enter agency code',
    ERE102: 'Please enter a valid agency code',
  },
  user_name: {
    ERE101: 'Please enter username',
    ERE102: 'Please enter a valid username',
  },
}

let pwsEx = alphanumericSpecialChars

export default function Theme10(props) {
  const router = useRouter()
  const loginType = props?.pageInfo?.site?.login_type || 'only_password'
  const [type, setType] = useState('Signin')
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState('')
  const [isOpen, setIsOpen] = useState(false)
  const [logincred, setLogincred] = useState({ agency_code: '', user_name: '', password: '' })
  const [loginErrors, setLoginErrors] = useState({ agency_code: '', user_name: '', password: '' })
  const [forgetcred, setForgetcred] = useState({ agency_code: '', user_name: '', password: '' })
  const [forgetErrors, setForgetErrors] = useState({ agency_code: '', user_name: '', password: '' })
  const [onClickLoginLoader, setOnClickLoginLoader] = useState(false)
  const [countryName, setCountryName] = useState([])
  const [isDisplay, setIsDisplay] = useState({
    email: true,
    password: false,
    otp: false,
    loginBtn: true,
    forgotPass: false,
  })
  const [forgotPasswordErr, setForgotPasswordErr] = useState('')
  const [loginErrMsg, setLoginErrMsg] = useState('')
  const [signupForm, setSignupForm] = useState({
    firstName: '',
    lastName: '',
    mobileNo: '',
    companyName: '',
    nationality: '',
    email: '',
    address: '',
    pincode: '',
    city: '',
    isdCode: '+91',
    orgName: '',
  })
  const [signupFormErr, setSignupFormErr] = useState({
    firstName: '',
    lastName: '',
    mobileNo: '',
    companyName: '',
    nationality: '',
    email: '',
    address: '',
    pincode: '',
    city: '',
    remark: '',
    isdCode: '',
    orgName: '',
  })
  const [originCountries, setOriginCountries] = useState([])
  const [selectedNationality, setSelectedNationality] = useState('')
  const [CountryCode, setCountryCode] = useState('')
  const [passwordObj, setPasswordObj] = useState({ newPassword: '', confirmPassword: '' })
  const [passwordObjErr, setPasswordObjErr] = useState({ newPassword: '', confirmPassword: '' })
  const [passwordUpdate, setPasswordUpdate] = useState(false)
  const [changePasswordAPIErr, setChangePasswordAPIErr] = useState('')
  const [resettokenExpiry, setResetTokenExpiry] = useState(false)
  const [cityList, setCityList] = useState([])
  const [selectedcity, setselectedCity] = useState('')
  const [CityCode, setCityCode] = useState('')
  const [state, setState] = useState({
    searchCountryText: '+91',
    demoForm: { countryCode: '' },
    demoFormErr: { countryCode: '' },
    selectedCountry: '',
  })
  const [showPassword, setShowPassword] = useState(false)
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showNewConfPassword, setShowNewConfPassword] = useState(false)
  const [fields, setFields] = useState({
    emailField: false,
    passwordField: false,
    otpField: false,
    loginWithOtpTxt: false,
  })
  const [showOtp, setShowOtp] = useState(false)
  const [loginWithOtp, setLoginWithOtp] = useState(true)
  const [otpLength, setOtpLength] = useState(0)
  const [exp_time, setExpTime] = useState()
  const [isOtpValid, setIsOtpValid] = useState(false)
  const [isForgotPassSent, setIsForgotPassSent] = useState(false)
  const [isContactUsConfirm, SetIsContactUsConfirm] = useState(false)
  const [isSendOtp, SetIsSendOtp] = useState(false)
  const OrganisationList = [
    'Construction',
    'Defense',
    'Educational',
    'Engineering',
    'Entertainment',
    'Financial',
    'Government',
    'Infrastructure',
    'Medical',
    'Pharmaceutical',
    'Private Sector',
    'Public Sector',
    'Technology',
    'Telecom',
    'Travel Agency',
  ]
  const TitleList = ['Mr', 'Mrs', 'Ms']

  const [selectdropdown, setselectdropdown] = useState({
    selectedOrg: '',
    selectedCr: '',
    selectedIsd: '',
  })
  const [captchStates, setCaptchStates] = useState({
    captchErrorMsg: '',
    isCaptchaSelected: false,
    captchErrorMsg: '',
  })
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [isMatch, setIsMatch] = useState(false)
  const [isValid, setIsValid] = useState(false)
  const [success, setSuccess] = useState(false)
  const [passwordValidation, setPasswordValidation] = useState()
  const [formData, setFormData] = useState({
    senderName: '',
    senderEmail: '',
    agencyName: '',
    agencyEmail: '',
    contactPersonName: '',
    isdCode: '+91',
    contactNumber: '',
    country: [],
    agencyCode: '',
    username: '',
    remarks: '',
  })
  const [registerForm, setregisterForm] = useState({
    agencyName: '',
    agencyCountry: [],
    agencyState: [],
    agencyCity: [],
    agencyAddress: '',
    agencyPincode: '',
    busAgencyEmail: '',
    busIsdCode: '+91',
    busContactNumber: '',
    admTitle: '',
    admfirstName: '',
    admLastName: '',
    adminEmail: '',
    admIsdCode: '+91',
    admContactNumber: '',
  })

  const [registerFormErr, setregisterFormErr] = useState({})

  const [errors, setErrors] = useState({})
  const [rememberMe, setRememberMe] = useState(false)
  const [loginErrCode, setLoginErrCode] = useState('')
  const [CityListData, setCityListData] = useState([])
  const [StateListData, setStateListData] = useState([])

  // const newPassword = `Create a Strong and unique password with a mix of letters,numbers and symbols,such as "N4&VQ2!p"`
  const siteName = props?.pageInfo?.site?.site_name || ' '

  const imgLogo = props?.pageInfo?.data?.signin?.upload_logo
    ? '/shared/api/media/' + props?.pageInfo?.data?.signin?.upload_logo
    : ''
  const imgMain = props?.pageInfo?.data?.signin?.upload_image
    ? '/shared/api/media/' + props?.pageInfo?.data?.signin?.upload_image
    : ''
  const stateUpdate = () => {
    setFormData({
      senderName: '',
      senderEmail: '',
      agencyName: '',
      agencyEmail: '',
      contactPersonName: '',
      isdCode: '+91',
      contactNumber: '',
      country: '',
      agencyCode: '',
      username: '',
      remarks: '',
    })
    setForgetcred({ agency_code: '', user_name: '', password: '' })

    if (!rememberMe) {
      setLogincred({ agency_code: '', user_name: '', password: '' })
    }
    setregisterForm({
      agencyName: '',
      agencyCountry: [],
      agencyState: [],
      agencyCity: [],
      agencyAddress: '',
      agencyPincode: '',
      busAgencyEmail: '',
      busIsdCode: '+91',
      busContactNumber: '',
      admTitle: '',
      admfirstName: '',
      admLastName: '',
      adminEmail: '',
      admIsdCode: '+91',
      admContactNumber: '',
    })
  }
  useEffect(() => {
    getLoginFields(loginType)
    getCountriesList().then((resp) => {
      let countryList = []
      if (resp?.data?.length > 0) {
        resp?.data.map((item) => {
          countryList.push({
            ...item,
            value: item.contry_name,
            isdCode: item.contry_isd,
            countryCode: item.contry_code,
            flag: item.contry_flag,
            countryFlag: item.contry_flag,
            countryName: item.contry_name,
            id: item.contry_code,
            label: item.contry_name,
            value: item.contry_code,
          })
        })
      }
      setOriginCountries(countryList)
    })

    if (
      router.query &&
      router.query.resettoken &&
      router.query.resettoken !== '' &&
      router.query.resettoken !== null &&
      (router.query?.type?.trim() == 'B2B' || router.query?.type?.trim() == 'B2E')
    ) {
      let response = {
        resettoken: router?.query?.resettoken,
        site_id: props?.home?.data?.site.id,
      }
      try {
        tokenExpiry(response).then((resp) => {
          if (resp && resp.data.status) {
            //setResetTokenExpiry(false)
            setType('ResetPassword')
          } else {
            // setResetTokenExpiry(true);
            setType('resettokenExpiry')
          }
        })
      } catch (error) {}
    }
  }, [])

  useEffect(() => {
    const savedAgencyCode = Cookies.get('agency_code')
    const savedUserName = Cookies.get('user_name')
    const savedPassword = Cookies.get('password')
    let decryptedPassword = savedPassword ? decryptData(savedPassword) : ''
    if (savedAgencyCode || savedUserName || savedPassword) {
      setLogincred({
        agency_code: savedAgencyCode || '',
        user_name: savedUserName || '',
        password: decryptedPassword || '',
      })
      setRememberMe(true)
      if (decryptedPassword) {
        document.getElementById('password').value = decryptedPassword
      }
    }
  }, [])

  const getLoginFields = (type) => {
    switch (type) {
      case 'only_password':
        setFields((prevState) => ({
          ...prevState,
          emailField: true,
          passwordField: true,
          otpField: false,
          loginWithOtpTxt: false,
        }))
        break
      case 'only_otp':
        setFields((prevState) => ({
          ...prevState,
          emailField: true,
          passwordField: false,
          otpField: true,
          loginWithOtpTxt: false,
        }))
        break
      case 'password_or_otp':
        setFields((prevState) => ({
          ...prevState,
          emailField: true,
          passwordField: true,
          otpField: true,
          loginWithOtpTxt: true,
        }))
        break
      case 'two_step_auth':
        setFields((prevState) => ({
          ...prevState,
          emailField: true,
          passwordField: true,
          otpField: true,
          loginWithOtpTxt: false,
        }))
        break
      default:
        setFields((prevState) => ({
          ...prevState,
          emailField: true,
          passwordField: true,
          otpField: false,
          loginWithOtpTxt: false,
        }))
        break
    }
  }

  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    // Check if the screen width is less than or equal to 768px (mobile breakpoint)
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 599)
    }

    // Set initial value
    handleResize()

    // Add event listener for window resize
    window.addEventListener('resize', handleResize)

    // Cleanup event listener on component unmount
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const onChangeForgetPassword = (e, id, type) => {
    if (type !== 'click') {
      const { value } = e?.target

      // Define validation rules for each field
      const validationRules = {
        agency_code: alphanumeric,
        user_name: alphanumericWithUnderscore,
        password: alphanumericSpecialChars,
      }

      // Get the validation rule for the current field
      const regex = validationRules[id]

      // Validate the input value
      if (!value.replace(regex, '')) {
        setForgetcred((prevState) => ({
          ...prevState,
          [id]: value,
        }))
      }
    }
    setForgetErrors((prevState) => ({
      ...prevState,
      [id]: '',
    }))
    setForgotPasswordErr('')
  }

  const onClickForgotSubimitBtn = () => {
    setForgetErrors({
      ...forgetErrors,
      agency_code:
        forgetcred.agency_code === ''
          ? errorsList.agency_code.ERE101
          : forgetcred.agency_code.match(alphanumericSpecialChars) !== null
            ? ''
            : errorsList.agency_code.ERE102,
      user_name:
        forgetcred.user_name === ''
          ? errorsList.user_name.ERE101
          : forgetcred.user_name.match(alphanumericSpecialChars) !== null
            ? ''
            : errorsList.agency_code.ERE102,
      password: '',
    })

    if (forgetcred.agency_code !== '' && forgetcred.user_name !== '') {
      let forgotPassReq = {
        username: forgetcred.user_name,
        code: forgetcred.agency_code,
      }

      setOnClickLoginLoader(true)

      try {
        forgotpassword(forgotPassReq).then((res) => {
          if (res && res.status === true && res.message && res.message !== '') {
            if (loginType == 'two_step_auth') {
              setIsDisplay({ email: false, password: false, loginBtn: false, otp: true })
              setShowOtp(true)
              setType('Signin')
              setExpTime(res?.otp?.otp_expiry_time || 180000)
              setOtpLength(res?.otp?.otp_length)
              setFields({ ...fields, emailField: false, passwordField: false })
            } else {
              // setIsOpen(true);
              setType('ForgotPassMail')
            }
          } else {
            setIsOpen(false)
            setForgotPasswordErr(res.message)
          }
          setOnClickLoginLoader(false)
        })
      } catch (error) {
        setOnClickLoginLoader(false)
      }
    } else {
      setIsOpen(false)
    }
  }

  // Login Functinality Starts
  const onChangeLoginField = (e, id, type) => {
    if (type !== 'click') {
      const { value } = e?.target

      // Define validation rules for each field
      const validationRules = {
        agency_code: alphanumeric,
        user_name: alphanumericWithUnderscore,
        password: alphanumericWithSpecialCharNoSpace,
      }

      // Get the validation rule for the current field
      const regex = validationRules[id]

      // Validate the input value
      if (!value.replace(regex, '')) {
        setLogincred((prevState) => ({
          ...prevState,
          [id]: value,
        }))
      }
    }
    setLoginErrors((prevState) => ({
      ...prevState,
      [id]: '',
    }))
    setLoginErrMsg('')
  }

  //login in button
  const onClickLoginBtn = () => {
    setLoginErrors({
      ...loginErrors,
      agency_code:
        logincred.agency_code === ''
          ? errorsList.agency_code.ERE101
          : logincred.agency_code.match(alphanumericSpecialChars) !== null
            ? ''
            : errorsList.agency_code.ERE102,
      user_name:
        logincred.user_name === ''
          ? errorsList.user_name.ERE101
          : logincred.user_name.match(alphanumericSpecialChars) !== null
            ? ''
            : errorsList.agency_code.ERE102,
      password:
        logincred.password === ''
          ? errorsList.password.ERP104
          : logincred.password.match(passwordRegex) !== null
            ? ''
            : errorsList.password.ERP105,
    })

    setLoginErrMsg('')
    onLoginWithPass()
  }
  //Login Func Ended

  const onLoginWithPass = () => {
    if (
      logincred.agency_code !== '' &&
      logincred.user_name !== '' &&
      logincred.password !== '' &&
      logincred.password.match(passwordRegex) !== null
    ) {
      let encryptedPassword = encryptData(logincred.password)
      let loginReq = {
        code: logincred.agency_code,
        username: logincred.user_name,
        password: encryptedPassword,
        //crypto: true ? true : false,
      }
      setOnClickLoginLoader(true)

      try {
        login(loginReq).then((responseJSON) => {
          let showdisclaimer =
            responseJSON?.type === 'B2E' && responseJSON?.user_type === 'CT' ? true : false

          if (
            responseJSON.status === true &&
            responseJSON.accessToken !== '' &&
            responseJSON.accessToken !== undefined &&
            responseJSON.accessToken !== null
          ) {
            handleRememberMe()
            localStorage.setItem('showdisclaimer', showdisclaimer)
            window.location.href = '/'
          } else {
            if (
              responseJSON.err_code == 'USER_NOT_FOUND' ||
              responseJSON.err_code == 'INVALID_CREDENTIALS'
            ) {
              setLoginErrMsg('Username / Password is Invalid.')
              setLoginErrCode(responseJSON.err_code)
              setOnClickLoginLoader(false)
            } else if (responseJSON.err_code == 'INVALID_AGENCY_CODE') {
              setLoginErrMsg('Agency Code is Invalid.')
              setLoginErrCode('INVALID_AGENCY_CODE')
              setOnClickLoginLoader(false)
            } else {
              setLoginErrMsg('User is not Active. Connect with Admin.')
              setLoginErrCode('USER_NOT_ACTIVE')
              setOnClickLoginLoader(false)
            }
          }
        })
      } catch (error) {
        setOnClickLoginLoader(false)
      }
    }
  }

  const onChangeSignFName = (e) => {
    let regex = e.target.value.replace(alphabetNameChars, '')
    if (!regex) {
      setSignupForm({ ...signupForm, firstName: e.target.value })
      setSignupFormErr({ ...signupFormErr, firstName: '' })
    }
  }

  const onChangeSignLName = (e) => {
    let regex = e.target.value.replace(alphabetNameChars, '')
    if (!regex) {
      setSignupForm({ ...signupForm, lastName: e.target.value })
      setSignupFormErr({ ...signupFormErr, lastName: '' })
    }
  }

  const onChangeSignCompanyName = (e) => {
    let regex = e.target.value.replace(alphabetNameChars, '')
    if (!regex) {
      setSignupForm({ ...signupForm, companyName: e.target.value })
      setSignupFormErr({ ...signupFormErr, companyName: '' })
    }
  }

  const onChangeRemarks = (e) => {
    let regex = e.target.value.replace(aplhaNumericDash, '')
    if (!regex) {
      setSignupForm({ ...signupForm, remark: e.target.value })
    }
  }

  const onChangeSignEmail = (e) => {
    let regex = e.target.value.replace(alphanumericSpecialChars, '')
    if (!regex) {
      setSignupForm({ ...signupForm, email: e.target.value })
      setSignupFormErr({ ...signupFormErr, email: '' })
    }
  }

  const onChangeNewPassword = (e) => {
    if (e.target.value.match(spaceRestrict) && e.target.value.match(passRestrict)) {
      setPasswordObj({ ...passwordObj, newPassword: e.target.value })
      setPasswordObjErr({ ...passwordObjErr, newPassword: '' })
    }
  }

  const onChangeConfirmPassword = (e) => {
    if (e.target.value.match(spaceRestrict) && e.target.value.match(passRestrict)) {
      setPasswordObj({ ...passwordObj, confirmPassword: e.target.value })
      setPasswordObjErr({ ...passwordObjErr, confirmPassword: '' })
    }
  }

  const onClickConfirmbtn = () => {
    setPasswordObjErr({
      ...passwordObjErr,
      newPassword: passwordObj.newPassword === '' ? errorsList.password.ERP104 : '',
      confirmPassword: passwordObj.confirmPassword === '' ? errorsList.confirmPassword.ERP102 : '',
    })

    // Check if passwords do not match
    if (passwordObj.newPassword !== passwordObj.confirmPassword) {
      setPasswordObjErr((prev) => ({
        ...prev,
        confirmPassword: errorsList.confirmPassword.ERP103,
      }))
      return
    }

    if (passwordObj.newPassword !== '' && passwordObj.confirmPassword !== '' && isValid) {
      let changePassReq = {
        confirm_password: encryptData(passwordObj.confirmPassword),
        new_password: encryptData(passwordObj.newPassword),
        resettoken: router.query.resettoken,
        crypto: true,
      }
      setOnClickLoginLoader(true)

      try {
        changepassword(changePassReq).then((res) => {
          if (res && res.status === true) {
            setType('ResetPasswordSuccess')
            setChangePasswordAPIErr('')
            setOnClickLoginLoader(false)
          } else {
            setChangePasswordAPIErr(res.message)
            setOnClickLoginLoader(false)
          }
        })
      } catch (error) {
        setOnClickLoginLoader(false)
      }
    }
  }

  const handleTogglePassword = () => {
    setShowPassword(!showPassword)
  }

  const handleViewNewPass = () => {
    setShowNewPassword(!showNewPassword)
  }
  const handleViewConfNewPass = () => {
    setShowNewConfPassword(!showNewConfPassword)
  }

  const onChangeOrg = (value, type) => {
    let values = value.replace(aplhaNumericDash, '').trim()

    setSignupForm({ ...signupForm, orgName: values })
    setSignupFormErr({ ...signupFormErr, orgName: '' })
    type == 'change'
      ? setselectdropdown({ ...selectdropdown, selectedOrg: '' })
      : setselectdropdown({ ...selectdropdown, selectedOrg: values })
    let selectedOrganization = []
    if (values !== '') {
      selectedOrganization = OrganisationList.filter((item) =>
        item.toLowerCase().includes(values.toLowerCase())
      )
    } else {
      selectedOrganization = OrganisationList
    }
  }

  const setCaptchDataCallBack = (bool, errorMsg) => {
    setCaptchStates({ isCaptchaSelected: bool })
  }

  const BackToForgotPassword = () => {
    cf.redirectTo('/login')
    setType('Forgotpassword')
  }

  const handleRememberMe = () => {
    if (rememberMe) {
      // Save credentials in cookies without expiration
      Cookies.set('agency_code', logincred.agency_code)
      Cookies.set('user_name', logincred.user_name)
      Cookies.set('password', encryptData(logincred.password))
    } else {
      // Remove credentials from cookies
      Cookies.remove('agency_code')
      Cookies.remove('user_name')
      Cookies.remove('password')
    }
  }

  const validatePassword = (password) => {
    const length = password?.length >= 8 && password?.length <= 20
    const uppercase = /[A-Z]/.test(password || '')
    const number = /\d/.test(password || '')
    const special = /[!@#$%^&*(),.?":{}|<>]/.test(password || '')

    setIsValid(length && uppercase && number && special)
    return { length, uppercase, number, special }
  }
  useEffect(() => {
    const validation = validatePassword(passwordObj?.newPassword)
    setPasswordValidation(validation)
    setIsValid(validation.length && validation.uppercase && validation.number && validation.special)
  }, [passwordObj?.newPassword])

  const handlePasswordChange = (e) => {
    const value = e.target.value
    if (alphanumericWithSpecialCharNoSpace.test(value)) {
      setPasswordObj({ ...passwordObj, newPassword: value })
      setPasswordObjErr({ ...passwordObjErr, newPassword: '' })
      validatePassword(value)
    }
    // If not matching, do not update state
  }

  const handleConfirmPassword = (e) => {
    const value = e.target.value
    if (alphanumericWithSpecialCharNoSpace.test(value)) {
      setPasswordObj({ ...passwordObj, confirmPassword: value })
      setPasswordObjErr({ ...passwordObjErr, confirmPassword: '' })
      setIsMatch(value === passwordObj?.newPassword)
    }
    // If not matching, do not update state
  }

  const handleIsdSelect = (ele, isd, id) => {
    if (ele && isd && id == 'isdCode') {
      setFormData({ ...formData, isdCode: isd.label })
    } else {
      setregisterForm((prevState) => ({
        ...prevState,
        [id]: isd?.label,
      }))
    }
  }

  const onChangeSignMobile = (value, type) => {
    if (type === 'contactNumber') {
      setFormData({ ...formData, [type]: value })
      setErrors((prevState) => ({
        ...prevState,
        [type]: '',
      }))
    } else {
      setregisterForm((prevState) => ({
        ...prevState,
        [type]: value,
      }))
      setregisterFormErr((prevState) => ({
        ...prevState,
        [type]: '',
      }))
    }
  }
  const handleChange = (value, id) => {
    // Validation rules for each field
    const validationRules = {
      senderName: alphabetNameChars, // Only alphabets and spaces
      senderEmail: '', // Valid email format
      agencyName: '', // Non-empty
      agencyEmail: '', // Valid email format
      senderEmail: noLeadingSpace, // Valid email format
      agencyName: noLeadingSpace, // Non-empty
      agencyEmail: noLeadingSpace, // Valid email format
      contactPersonName: alphabetNameChars, // Only alphabets and spaces
      isdCode: onlyNumber, // Non-empty
      contactNumber: mobileNumberZeroRegex, // Only numbers
      country: '', // Non-empty
      remarks: '', // Non-empty
      remarks: noLeadingSpace, // Non-empty
      username: onlyAlphabets,
      agencyCode: noLeadingSpace, // Alphanumeric with underscore
    }

    // Check if the field has a validation rule
    if (validationRules[id]) {
      const regex = validationRules[id]
      if (!regex.test(value) && value !== '') {
        // Prevent invalid input by not updating the state
        return
      }
    }

    setFormData({ ...formData, [id]: value })
    // Clear the error for the field
    setErrors((prevState) => ({
      ...prevState,
      [id]: '',
    }))
  }

  const handleSelectionChange = (value, id) => {
    if (id === 'country') {
      setFormData({ ...formData, [id]: value })
      setCountryName(value)
      setErrors((prevState) => ({
        ...prevState,
        [id]: '',
      }))
    } else {
      setregisterForm((prevState) => ({
        ...prevState,
        [id]: value,
      }))
      setregisterFormErr((prevState) => ({
        ...prevState,
        [id]: '',
      }))
    }

    if (id === 'agencyCountry') {
      let reqdata = {
        country_name: value?.[0]?.countryName || '',
      }
      getStateApi(reqdata).then((res) => {
        let stateData = []
        if (res && res.data && res.data.length > 0) {
          res?.data.map((item) => {
            stateData.push({
              id: item.state_code,
              label: item.state_name,
              value: item.state_code,
            })
          })
        }
        setStateListData(stateData)
      })
    }
    if (id === 'agencyState') {
      let reqdata = {
        country_name: registerForm.agencyCountry?.[0]?.label + '/' + value?.[0]?.label || '',
      }
      getCityByCountry(reqdata).then((res) => {
        let cityData = []
        if (res && res.data && res.data.length > 0) {
          res?.data.map((item) => {
            cityData.push({
              id: item.city_code,
              label: item.city_name,
              value: item.city_code,
            })
          })
        }
        setCityListData(cityData)
      })
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (validate()) {
      if (!captchStates.isCaptchaSelected) {
        setCaptchStates((prevState) => ({
          ...prevState,
          captchErrorMsg: 'Please complete the captcha to proceed.',
        }))
        return // Stop further execution if captcha is not selected
      }
      let request = {
        site_id: props?.home?.data?.site.id || '',
        sender: {
          name: formData?.senderName,
          email: formData?.senderEmail,
        },
        agency: {
          name: formData?.agencyName,
          email: formData?.agencyEmail,
        },
        contact: {
          name: formData?.contactPersonName,
          isd_code: formData?.isdCode,
          number: formData?.contactNumber,
        },
        agency_code: formData?.agencyCode,
        username: formData?.username,
        country: {
          code: formData?.country?.[0]?.value,
          name: formData?.country?.[0]?.label,
        },
        remarks: formData?.remarks,
      }
      setOnClickLoginLoader(true)

      try {
        forgetAgencyCodeUsename(request).then((responseJSON) => {
          setType('ForgotAgencyUserNameSuccess')
          setOnClickLoginLoader(false)
          setCaptchStates((prevState) => ({
            ...prevState,
            isCaptchaSelected: false,
            captchErrorMsg: '',
          }))
        })
      } catch (error) {
        setOnClickLoginLoader(false)
      }
    }
  }

  const validate = () => {
    const newErrors = {}

    // Validation rules
    if (!formData.senderName.match(alphabetNameChars)) {
      newErrors.senderName = 'Please enter sender name'
    }
    if (!formData.senderEmail) {
      newErrors.senderEmail = 'Please enter sender email ID'
    } else if (!formData.senderEmail.match(validEmailRegex)) {
      newErrors.senderEmail = 'Please enter a valid sender email ID'
    }
    if (!formData.agencyName) {
      newErrors.agencyName = 'Please enter an agency name'
    }
    if (!formData.agencyEmail) {
      newErrors.agencyEmail = 'Please enter an agency email ID'
    } else if (!formData.agencyEmail.match(validEmailRegex)) {
      newErrors.agencyEmail = 'Please enter a valid agency email ID'
    }
    if (!formData.contactPersonName.match(alphabetNameChars)) {
      newErrors.contactPersonName = 'Please enter contact person name'
    } else if (!formData.isdCode) {
      newErrors.isdCode = 'Please select an ISD Code'
    }
    if (!formData.contactNumber) {
      newErrors.contactNumber = 'Please enter contact number'
    } else if (formData.contactNumber.length < 7) {
      newErrors.contactNumber = 'Please enter a valid contact number'
    }
    if (!formData.country || formData.country.length === 0) {
      newErrors.country = 'Please select a country'
    }
    if (!formData.remarks) {
      newErrors.remarks = 'Please enter remarks'
    }

    if (formData?.agencyCode && formData.agencyCode.length < 3) {
      newErrors.agencyCode = 'Agency code character should be min 3'
    }

    if (formData?.username && formData.username.length < 3) {
      newErrors.username = 'Username character should be min 3'
    }

    if (formData.username.length < 3) {
      newErrors.username = 'Username character should be min 3'
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const validateRegisterForm = () => {
    const newErrors = {}

    // Validation rules
    if (!registerForm.agencyName) {
      newErrors.agencyName = 'Please enter agency name'
    }
    if (!registerForm.agencyCountry || registerForm.agencyCountry.length === 0) {
      newErrors.agencyCountry = 'Please select a country'
    }
    if (!registerForm.agencyState || registerForm.agencyState.length === 0) {
      newErrors.agencyState = 'Please select a state'
    }
    if (!registerForm.agencyCity || registerForm.agencyCity.length === 0) {
      newErrors.agencyCity = 'Please select a city'
    }
    if (!registerForm.busAgencyEmail) {
      newErrors.busAgencyEmail = 'Please enter business email ID'
    } else if (!registerForm.busAgencyEmail.match(validEmailRegex)) {
      newErrors.busAgencyEmail = 'Please enter a valid business email ID'
    }
    if (!registerForm.busContactNumber) {
      newErrors.busContactNumber = 'Please enter business contact number'
    } else if (registerForm.busContactNumber.length < 7) {
      newErrors.busContactNumber = 'Please enter a valid business contact number'
    } else if (
      !registerForm.busIsdCode ||
      registerForm.busIsdCode == undefined ||
      registerForm.busIsdCode == 'undefined'
    ) {
      newErrors.busIsdCode = 'Please select a ISD Code'
    }

    if (!registerForm.admfirstName) {
      newErrors.admfirstName = 'Please enter first name'
    } else if (!registerForm.admTitle) {
      newErrors.admTitle = 'Please select a title'
    }
    if (!registerForm.admLastName) {
      newErrors.admLastName = 'Please enter last name'
    }
    if (!registerForm.adminEmail) {
      newErrors.adminEmail = 'Please enter admin email ID'
    } else if (!registerForm.adminEmail.match(validEmailRegex)) {
      newErrors.adminEmail = 'Please enter a valid admin email ID'
    }
    if (!registerForm.admContactNumber) {
      newErrors.admContactNumber = 'Please enter admin mobile number'
    } else if (registerForm.admContactNumber.length < 7) {
      newErrors.admContactNumber = 'Please enter a valid admin mobile number'
    } else if (
      !registerForm.admIsdCode ||
      registerForm.admIsdCode == 'undefined' ||
      registerForm.admIsdCode == undefined
    ) {
      newErrors.admIsdCode = 'Please select an ISD Code'
    }

    // Set errors if any
    setregisterFormErr(newErrors)

    // Return true if no errors, otherwise false
    return Object.keys(newErrors).length === 0
  }
  const onSubmitRegister = () => {
    if (validateRegisterForm()) {
      if (!captchStates.isCaptchaSelected) {
        setCaptchStates((prevState) => ({
          ...prevState,
          captchErrorMsg: 'Please complete the captcha to proceed.',
        }))
        return // Stop further execution if captcha is not selected
      }
      // Prepare the request payload
      const requestPayload = {
        agencyName: registerForm.agencyName,
        agencyCountry: registerForm.agencyCountry,
        agencyState: registerForm.agencyState,
        adminEmail: registerForm.adminEmail,
      }
      let registerReq = {
        site_id: props?.home?.data?.site.id || '',
        title: registerForm.admTitle,
        first_name: registerForm.admfirstName,
        last_name: registerForm.admLastName,
        company_name: registerForm.agencyName,
        mobile_number: registerForm.admContactNumber,
        email: registerForm.adminEmail,
        country: {
          name: registerForm.agencyCountry?.[0]?.label,
          code: registerForm.agencyCountry?.[0]?.value,
        },
        city: {
          name: registerForm.agencyCity?.[0]?.label,
          code: registerForm.agencyCity?.[0]?.value,
        },
        state: {
          name: registerForm.agencyState?.[0]?.label,
          code: registerForm.agencyState?.[0]?.value,
        },
        address: registerForm.agencyAddress,
        pincode: registerForm.agencyPincode,
        remark: '',
        company_type: '',
        isd_code: registerForm.admIsdCode,
        b_email: registerForm.busAgencyEmail,
        b_mobile_number: registerForm.busContactNumber,
        b_isd_code: registerForm.busIsdCode,
      }

      setOnClickLoginLoader(true)

      try {
        contactus(registerReq).then((res) => {
          if (res && res.status && res.message !== '') {
            setType('RegisterSuccess')
            setOnClickLoginLoader(false)
            setCaptchStates((prevState) => ({
              ...prevState,
              isCaptchaSelected: false,
              captchErrorMsg: '',
            }))
          } else {
          }
        })
      } catch (error) {
        setOnClickLoginLoader(false)
      }
    } else {
      // console.log("Validation errors:", newErrors);
    }
  }

  const onChangeRegister = (e, id) => {
    const { value } = e?.target

    // Update the registerForm state dynamically only if validation passes
    const validationRules = {
      agencyName: alphanumericWithSpace,
      agencyPincode: alphanumeric,
      busAgencyEmail: '',
      busAgencyEmail: noLeadingSpace,
      busIsdCode: mobileNumberZeroRegex,
      admTitle: onlyAlphabets,
      admfirstName: alphabetsAndSpaces,
      admLastName: alphabetsAndSpaces,
      adminEmail: '',
      adminEmail: noLeadingSpace,
      admIsdCode: mobileNumberZeroRegex,
      agencyAddress: noLeadingSpace,
    }

    if (validationRules[id] && !validationRules[id].test(value) && value !== '') {
      return // Prevent updating the state if validation fails
    }

    setregisterForm((prevState) => ({
      ...prevState,
      [id]: value,
    }))

    // Clear the error for the field
    setregisterFormErr((prevState) => ({
      ...prevState,
      [id]: '',
    }))
  }

  const onChangeTitle = (value, id, type) => {
    setregisterForm((prevState) => ({
      ...prevState,
      [type]: value,
    }))
    setregisterFormErr((prevState) => ({
      ...prevState,
      [id]: '',
    }))
  }

  const redirectToLogin = () => {
    cf.redirectTo('/login')
    setType('Signin')
  }

  // Resets all form-related states to their initial values and navigates to login
  const handleBackToLogin = () => {
    setCaptchStates((prevState) => ({
      ...prevState,
      isCaptchaSelected: false,
      captchErrorMsg: '',
    }))
    setCountryName([])
    setCityListData([])
    setStateListData([])
    if (!rememberMe) {
      setLogincred({ agency_code: '', user_name: '', password: '' })
    }
    setLoginErrors({ agency_code: '', user_name: '', password: '' })
    setForgetErrors({ agency_code: '', user_name: '', password: '' })
    setForgetcred({ agency_code: '', user_name: '', password: '' })
    setFormData({
      senderName: '',
      senderEmail: '',
      agencyName: '',
      agencyEmail: '',
      contactPersonName: '',
      isdCode: '+91',
      contactNumber: '',
      country: [],
      agencyCode: '',
      username: '',
      remarks: '',
    })
    setErrors({})
    setregisterForm({
      agencyName: '',
      agencyCountry: [],
      agencyState: [],
      agencyCity: [],
      agencyAddress: '',
      agencyPincode: '',
      busAgencyEmail: '',
      busIsdCode: '+91',
      busContactNumber: '',
      admTitle: '',
      admfirstName: '',
      admLastName: '',
      adminEmail: '',
      admIsdCode: '+91',
      admContactNumber: '',
    })
    setregisterFormErr({})
    setType('Signin')
  }

  const renderlogin = (value) => {
    switch (type) {
      case 'Signin':
        return (
          <>
            <div className={styles.login__form}>
              <div className={styles.login__form_container}>
                <header className={styles.login__form_header}>
                  <div className={styles.login__logo}>
                    <img src={imgLogo} alt="logo" className={styles.login__logo_image} />
                  </div>
                </header>

                <div className={styles.login__form_content}>
                  <div className={styles.login__form_title_wrapper}>
                    <h2 className={styles.login__form_title}>Agent Sign in</h2>
                  </div>
                  <div
                    className={`${styles.login__form_input_text_wrapper} ${loginErrMsg !== '' ? styles.padding_top : ''}`}
                  >
                    {loginErrMsg && (
                      <div className={styles?.single_login_error}>
                        <span className={styles.error_icon}>
                          <svg
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.16992 21L12.1699 2L23.1699 21H1.16992ZM4.61992 19H19.7199L12.1699 6L4.61992 19ZM12.1699 18C12.4533 18 12.6908 17.9042 12.8824 17.7125C13.0741 17.5208 13.1699 17.2833 13.1699 17C13.1699 16.7167 13.0741 16.4792 12.8824 16.2875C12.6908 16.0958 12.4533 16 12.1699 16C11.8866 16 11.6491 16.0958 11.4574 16.2875C11.2658 16.4792 11.1699 16.7167 11.1699 17C11.1699 17.2833 11.2658 17.5208 11.4574 17.7125C11.6491 17.9042 11.8866 18 12.1699 18ZM11.1699 15H13.1699V10H11.1699V15Z"
                              fill="#E53935"
                            />
                          </svg>
                        </span>
                        {loginErrMsg}
                      </div>
                    )}
                    <div
                      className={`${styles.input_container} ${loginErrors.agency_code !== '' || loginErrCode == 'INVALID_AGENCY_CODE' || loginErrCode == 'USER_NOT_ACTIVE' ? styles.input_container_error : ''}`}
                    >
                      <VmsInputText
                        id="agency_code"
                        value={logincred?.agency_code}
                        label={'agency_code'}
                        placeholder={`Agency Code`}
                        additionalClassName={CSS?.first_name_Add}
                        onChange={(e) => onChangeLoginField(e, 'agency_code')}
                        onClick={(e) => onChangeLoginField(e, 'agency_code', 'click')}
                      />
                      {loginErrors.agency_code !== '' ? (
                        <div className={styles.login_errors}>{loginErrors.agency_code}</div>
                      ) : (
                        ''
                      )}
                    </div>

                    <div
                      className={`${styles.input_container} ${loginErrors.user_name !== '' || loginErrCode == 'USER_NOT_FOUND' || loginErrCode == 'INVALID_CREDENTIALS' || loginErrCode == 'USER_NOT_ACTIVE' ? styles.input_container_error : ''}`}
                    >
                      <VmsInputText
                        id="user_name"
                        value={logincred?.user_name}
                        label={'user_name'}
                        placeholder={`Username`}
                        additionalClassName={CSS?.first_name_Add}
                        onChange={(e) => onChangeLoginField(e, 'user_name')}
                        onClick={(e) => onChangeLoginField(e, 'user_name', 'click')}
                      />
                      {loginErrors.user_name !== '' ? (
                        <div className={styles.login_errors}>{loginErrors.user_name}</div>
                      ) : (
                        ''
                      )}
                    </div>

                    <div
                      className={`${styles.input_container} ${loginErrors.password !== '' || loginErrCode == 'USER_NOT_FOUND' || loginErrCode == 'USER_NOT_ACTIVE' ? styles.input_container_error : ''}`}
                    >
                      <div className={styles.input_password_wrapper}>
                        <VmsInputText
                          id="password"
                          //value={logincred?.password}
                          label={'password'}
                          type={showPassword ? 'text' : 'password'}
                          placeholder={`Password`}
                          additionalClassName={CSS?.first_name_Add}
                          onChange={(e) => onChangeLoginField(e, 'password')}
                          onClick={(e) => onChangeLoginField(e, 'password', 'click')}
                          maxLength={'20'}
                        />
                        <div className={styles.pass_icon}>
                          <img
                            src={showPassword ? 'theme10/eye-on.svg' : 'theme10/eye-off.svg'}
                            alt="pass"
                            onClick={() => {
                              handleTogglePassword()
                            }}
                          />
                        </div>
                      </div>
                      {loginErrors.password !== '' ? (
                        <div className={styles.login_errors}>{loginErrors.password}</div>
                      ) : (
                        ''
                      )}
                      {/* <label htmlFor="password">Password</label> */}
                    </div>
                  </div>

                  <div>{isSendOtp && <div className={styles.loader}></div>}</div>

                  <div
                    className={`${isDisplay.loginBtn ? styles.login__actions : ''} ${onClickLoginLoader ? styles.loader_center : ''} ${isDisplay.loginBtn ? styles.forloaderonly : ''}`}
                  >
                    {isDisplay.loginBtn && (
                      <div
                        className={`${isDisplay.password ? '' : styles.buttonDisabled} ${styles.buttoncontainer}`}
                      >
                        <VmsButton
                          additionalClassName={`${styles.sign_in_btn}`}
                          onClick={() => {
                            onClickLoginBtn()
                          }}
                          isLoading={onClickLoginLoader}
                          disabled={
                            !logincred.agency_code || !logincred.password || !logincred.user_name
                          }
                        >
                          <span className={styles.button_text}>Sign in</span>
                        </VmsButton>{' '}
                      </div>
                    )}
                  </div>

                  <div className={styles.remember_checkbox}>
                    <VmsInputCheckbox
                      normallabel={'Remember me'}
                      id="rememberme"
                      checked={rememberMe}
                      onClick={(e) => {
                        setRememberMe(!rememberMe)
                      }}
                    />
                  </div>
                </div>

                <div className={styles.button_wrapper_forget_password}>
                  <button
                    type="button"
                    onClick={() => {
                      setType('Forgotpassword')
                      stateUpdate()
                    }}
                    className={styles.forget__pfassword}
                  >
                    Forgot Password?
                  </button>
                  <div className={styles.vertical_pipe}>|</div>
                  <button
                    onClick={() => {
                      setType('ForgotAgencyUserName')
                      stateUpdate()
                    }}
                    type="button"
                    className={styles.forget__pfassword}
                  >
                    Forgot Agency Code or Username?
                  </button>
                </div>

                <button
                  onClick={() => {
                    setType('RegisterAgency')
                    stateUpdate()
                  }}
                  type="button"
                  className={styles.new_register}
                >
                  New to {siteName}? <span className={styles.fontbold}>Register Your Agency</span>
                </button>

                {isMobile && (
                  <nav className={styles.login__nav}>
                    {props?.pageInfo?.data?.footer?.menu?.map(
                      (fLink, index) =>
                        fLink.active === 'active' && (
                          <a
                            key={index}
                            href={fLink.url}
                            className={styles.login__nav_link}
                            tabIndex="0"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {fLink.text}
                          </a>
                        )
                    )}
                  </nav>
                )}
              </div>
            </div>
          </>
        )
      case 'Forgotpassword':
        return (
          <>
            <div className={styles.login__form}>
              <div className={styles.login__form_container}>
                <header className={styles.login__form_header}>
                  <div
                    className={styles.login__logo}
                    onClick={() => {
                      redirectToLogin()
                    }}
                  >
                    <img src={imgLogo} alt="logo" className={styles.login__logo_image} />
                  </div>
                </header>

                <div className={styles.login__form_content}>
                  <div className={styles.login__form_title_wrapper}>
                    <h2 className={styles.login__form_title}>Forgot Password?</h2>
                    <div className={styles.login__form_subheading_wrapper}>
                      <p className={styles.login__form_subheading}>
                        Don&apos;t worry, happens to all of us.
                      </p>
                      <p className={styles.login__form_subheading}>
                        Enter your details below to recover your password
                      </p>
                    </div>
                  </div>

                  <div
                    className={`${styles.login__form_input_text_wrapper} ${forgotPasswordErr ? styles.padding_top : ''}`}
                  >
                    {forgotPasswordErr && (
                      <div className={styles?.single_login_error}>
                        <span className={styles.error_icon}>
                          <svg
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.16992 21L12.1699 2L23.1699 21H1.16992ZM4.61992 19H19.7199L12.1699 6L4.61992 19ZM12.1699 18C12.4533 18 12.6908 17.9042 12.8824 17.7125C13.0741 17.5208 13.1699 17.2833 13.1699 17C13.1699 16.7167 13.0741 16.4792 12.8824 16.2875C12.6908 16.0958 12.4533 16 12.1699 16C11.8866 16 11.6491 16.0958 11.4574 16.2875C11.2658 16.4792 11.1699 16.7167 11.1699 17C11.1699 17.2833 11.2658 17.5208 11.4574 17.7125C11.6491 17.9042 11.8866 18 12.1699 18ZM11.1699 15H13.1699V10H11.1699V15Z"
                              fill="#E53935"
                            />
                          </svg>
                        </span>
                        {forgotPasswordErr}
                      </div>
                    )}
                    <div
                      className={`${styles.input_container} ${forgotPasswordErr || forgetErrors.agency_code !== '' ? styles.input_container_error : ''}`}
                    >
                      <VmsInputText
                        id="agency_code"
                        value={forgetcred?.agency_code}
                        label={'agency_code'}
                        placeholder={`Agency Code`}
                        additionalClassName={CSS?.first_name_Add}
                        onChange={(e) => onChangeForgetPassword(e, 'agency_code')}
                        onClick={(e) => onChangeForgetPassword(e, 'agency_code', 'click')}
                      />
                      {forgetErrors.agency_code !== '' ? (
                        <div className={styles.login_errors}>{forgetErrors.agency_code}</div>
                      ) : (
                        ''
                      )}
                    </div>

                    <div
                      className={`${styles.input_container} ${forgotPasswordErr || forgetErrors.user_name !== '' ? styles.input_container_error : ''}`}
                    >
                      <VmsInputText
                        id="user_name"
                        value={forgetcred?.user_name}
                        label={'user_name'}
                        placeholder={`Username`}
                        additionalClassName={CSS?.first_name_Add}
                        onChange={(e) => onChangeForgetPassword(e, 'user_name')}
                        onClick={(e) => onChangeForgetPassword(e, 'user_name', 'click')}
                      />
                      {forgetErrors.user_name !== '' ? (
                        <div className={styles.login_errors}>{forgetErrors.user_name}</div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                  <div className={styles.login__actions}>
                    <div
                      className={`${isDisplay.password ? '' : styles.buttonDisabled} ${styles.buttoncontainer}`}
                    >
                      <VmsButton
                        additionalClassName={`${styles.sign_in_btn}`}
                        isLoading={onClickLoginLoader}
                        onClick={() => onClickForgotSubimitBtn()}
                        disabled={!forgetcred?.user_name || !forgetcred?.agency_code}
                      >
                        <> {'Submit'}</>
                      </VmsButton>{' '}
                    </div>
                  </div>

                  <button
                    onClick={() => handleBackToLogin()}
                    type="button"
                    className={styles.back_to_login}
                  >
                    Back to login
                  </button>
                </div>
              </div>
              {isOpen && (
                <ModalPopupComponent
                  modalCss={modalCss}
                  onClosePopup={() => {
                    setIsOpen(false)
                    setType('Signin')
                    setForgotPasswordEmail('')
                  }}
                  isPopup={isOpen}
                  isMobile={false}
                  showCrossButton={true}
                >
                  <div className={styles.modalb_wrap}>
                    <div className={styles.modb_icon}>
                      <img src="/images/email-icon.svg" alt="email" />
                    </div>
                    <div className={styles.modb_title}>
                      <div> We just sent you an email</div>
                      <div>Please follow the instructions in the email to access your account</div>
                    </div>
                    <button
                      className={styles.btn_login}
                      onClick={() => {
                        setIsOpen(false)
                        setType('Signin')
                        setForgotPasswordEmail('')
                      }}
                    >
                      Ok{' '}
                    </button>
                  </div>
                </ModalPopupComponent>
              )}
            </div>
          </>
        )
      case 'ResetPassword':
        return (
          <>
            <section className={styles.login__form}>
              <div className={styles.login__form_container}>
                <header className={styles.login__form_header}>
                  <div
                    className={styles.login__logo}
                    onClick={() => {
                      redirectToLogin()
                    }}
                  >
                    <img src={imgLogo} alt="logo" className={styles.login__logo_image} />
                  </div>
                </header>

                <div className={`${styles.login__form_content} ${styles.createpassword}`}>
                  <div
                    className={`${styles.login__form_title_wrapper} ${styles.flexall} ${styles.flexrow}`}
                  >
                    <h2 className={`${styles.login__form_title} ${styles.newpasswordtext}`}>
                      Reset Password
                    </h2>
                    <div className={styles.login__form_subheading_wrapper}>
                      <p className={styles.login__form_subheading}>
                        Please set a new password for your account.
                      </p>
                    </div>
                  </div>

                  <div
                    className={`${styles.login__form_input_text_wrapper} ${changePasswordAPIErr !== '' ? styles.padding_top : ''}`}
                  >
                    {changePasswordAPIErr && (
                      <div className={styles?.single_login_error}>
                        <span className={styles.error_icon}>
                          <svg
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.16992 21L12.1699 2L23.1699 21H1.16992ZM4.61992 19H19.7199L12.1699 6L4.61992 19ZM12.1699 18C12.4533 18 12.6908 17.9042 12.8824 17.7125C13.0741 17.5208 13.1699 17.2833 13.1699 17C13.1699 16.7167 13.0741 16.4792 12.8824 16.2875C12.6908 16.0958 12.4533 16 12.1699 16C11.8866 16 11.6491 16.0958 11.4574 16.2875C11.2658 16.4792 11.1699 16.7167 11.1699 17C11.1699 17.2833 11.2658 17.5208 11.4574 17.7125C11.6491 17.9042 11.8866 18 12.1699 18ZM11.1699 15H13.1699V10H11.1699V15Z"
                              fill="#E53935"
                            />
                          </svg>
                        </span>
                        {changePasswordAPIErr}
                      </div>
                    )}

                    <div className={styles.input_container}>
                      <div className={styles.input_password_wrapper}>
                        <div className={styles.input_password_icon_wrap}>
                          <VmsInputText
                            // value={passwordObj?.newPassword}
                            id="pass"
                            type={showNewPassword ? 'text' : 'password'}
                            placeholder="New Password"
                            secondPlaceHolder="Password"
                            onChange={(e) => handlePasswordChange(e)}
                            maxLength={'20'}
                          />
                          <div className={styles.pass_icon}>
                            <img
                              src={showNewPassword ? 'theme10/eye-on.svg' : 'theme10/eye-off.svg'}
                              alt="pass"
                              onClick={() => {
                                handleViewNewPass()
                              }}
                            />
                          </div>
                        </div>

                        {passwordObjErr.newPassword !== '' ? (
                          <div className={styles.login_errors}>{passwordObjErr.newPassword}</div>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                    <div className={styles.input_container}>
                      <div className={styles.input_password_wrapper}>
                        <div className={styles.input_password_icon_wrap}>
                          <VmsInputText
                            // value={passwordObj?.confirmPassword}
                            id="confirpass"
                            type={showNewConfPassword ? 'text' : 'password'}
                            placeholder="Re-enter Password"
                            onChange={(e) => handleConfirmPassword(e)}
                            maxLength={'20'}
                          />
                          <div className={styles.pass_icon}>
                            <img
                              src={
                                showNewConfPassword ? 'theme10/eye-on.svg' : 'theme10/eye-off.svg'
                              }
                              alt="pass"
                              onClick={() => {
                                handleViewConfNewPass()
                              }}
                            />
                          </div>
                        </div>

                        {passwordObjErr.confirmPassword !== '' ? (
                          <div className={styles.login_errors}>
                            {' '}
                            {passwordObjErr.confirmPassword}
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                    <div className={styles.reset_password_button_wrapper}>
                      <div className={styles.reset_password_button}>
                        <VmsButton
                          additionalClassName={`${isValid && isMatch ? styles.button_active : styles.reset_button_disable}`}
                          isLoading={onClickLoginLoader}
                          onClick={onClickConfirmbtn}
                          disabled={isValid && isMatch ? false : true}
                        >
                          Reset Password
                        </VmsButton>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.password_rules_wrapper}>
                  <p className={styles.password_rules_text}>Password must contain at least</p>
                  <ul className={styles.password_rules_main}>
                    <li className={styles.password_rules_list}>
                      <span
                        className={passwordValidation?.length ? styles.valid : styles.invalid}
                      ></span>
                      Between 8 to 20 characters
                    </li>
                    <li className={styles.password_rules_list}>
                      <span
                        className={passwordValidation?.uppercase ? styles.valid : styles.invalid}
                      ></span>
                      One uppercase letter
                    </li>
                    <li className={styles.password_rules_list}>
                      <span
                        className={passwordValidation?.number ? styles.valid : styles.invalid}
                      ></span>
                      One or more numbers
                    </li>
                    <li className={styles.password_rules_list}>
                      <span
                        className={passwordValidation?.special ? styles.valid : styles.invalid}
                      ></span>
                      One or more special characters
                    </li>
                  </ul>

                  {success && (
                    <p className={styles.successMessage}>
                      Password Reset Confirmed! A confirmation email has been sent.
                    </p>
                  )}
                </div>
              </div>
              {passwordUpdate && (
                <div className={styles.notification}>
                  <div className={styles.notification__content}>
                    <div className={styles.notification__indicator}></div>
                    <p className={styles.notification__message}>Password updated successfully</p>
                  </div>
                </div>
              )}
            </section>
          </>
        )
      case 'ForgotPassMail':
        return (
          <>
            <div className={styles.login__form}>
              <div className={styles.login__form_container}>
                <header className={styles.login__form_header}>
                  <div
                    className={styles.login__logo}
                    onClick={() => {
                      redirectToLogin()
                    }}
                  >
                    <img src={imgLogo} alt="logo" className={styles.login__logo_image} />
                  </div>
                </header>
                <div className={styles.login__form_content}>
                  <div className={styles.password_reset__container}>
                    <div className={styles.password_reset__header}>
                      <div className={styles.password_reset__icon_wrapper}>
                        <span className={styles.confirmed_icon}>
                          <svg
                            width="49"
                            height="49"
                            viewBox="0 0 49 49"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21.8699 33.7L35.9699 19.6L33.1699 16.8L21.8699 28.1L16.1699 22.4L13.3699 25.2L21.8699 33.7ZM24.6699 44.5C21.9033 44.5 19.3033 43.975 16.8699 42.925C14.4366 41.875 12.3199 40.45 10.5199 38.65C8.71992 36.85 7.29492 34.7333 6.24492 32.3C5.19492 29.8667 4.66992 27.2667 4.66992 24.5C4.66992 21.7333 5.19492 19.1333 6.24492 16.7C7.29492 14.2667 8.71992 12.15 10.5199 10.35C12.3199 8.55 14.4366 7.125 16.8699 6.075C19.3033 5.025 21.9033 4.5 24.6699 4.5C27.4366 4.5 30.0366 5.025 32.4699 6.075C34.9033 7.125 37.0199 8.55 38.8199 10.35C40.6199 12.15 42.0449 14.2667 43.0949 16.7C44.1449 19.1333 44.6699 21.7333 44.6699 24.5C44.6699 27.2667 44.1449 29.8667 43.0949 32.3C42.0449 34.7333 40.6199 36.85 38.8199 38.65C37.0199 40.45 34.9033 41.875 32.4699 42.925C30.0366 43.975 27.4366 44.5 24.6699 44.5ZM24.6699 40.5C29.1366 40.5 32.9199 38.95 36.0199 35.85C39.1199 32.75 40.6699 28.9667 40.6699 24.5C40.6699 20.0333 39.1199 16.25 36.0199 13.15C32.9199 10.05 29.1366 8.5 24.6699 8.5C20.2033 8.5 16.4199 10.05 13.3199 13.15C10.2199 16.25 8.66992 20.0333 8.66992 24.5C8.66992 28.9667 10.2199 32.75 13.3199 35.85C16.4199 38.95 20.2033 40.5 24.6699 40.5Z"
                              fill="#43A047"
                            />
                          </svg>
                        </span>
                      </div>
                      <div className={styles.password_reset__content}>
                        <h1 className={styles.password_reset__title}>Request Confirmed</h1>
                        <p className={styles.password_reset__description}>
                          Your request has been processed successfully. A link to reset your
                          password has been sent to your registered email ID.
                        </p>
                      </div>
                    </div>

                    <div className={styles.password_reset__divider}></div>

                    <button
                      onClick={() => handleBackToLogin()}
                      type="button"
                      className={styles.back_to_login}
                    >
                      Back to login
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )

      case 'resettokenExpiry':
        return (
          <>
            <section className={styles.login__form}>
              <div className={styles.login__form_container}>
                <header className={styles.login__form_header}>
                  <div
                    className={styles.login__logo}
                    onClick={() => {
                      redirectToLogin()
                    }}
                  >
                    <img src={imgLogo} alt="logo" className={styles.login__logo_image} />
                  </div>
                </header>

                <div className={`${styles.login__form_content} ${styles.createpassword}`}>
                  <div
                    className={`${styles.login__form_title_wrapper} ${styles.flexall} ${styles.flexrow}`}
                  >
                    <h2 className={`${styles.login__form_title} ${styles.newpasswordtext}`}>
                      Invalid Password Reset Link
                    </h2>
                    <div className={styles.login__form_subheading_wrapper}>
                      <p className={styles.login__form_subheading}>
                        This link has expired. Please click on "Reset" to request a new reset
                        password link.
                      </p>
                    </div>
                  </div>
                  <div className={styles.invalid_btns_flex}>
                    <div className={styles.buttoncontainer}>
                      <VmsButton
                        additionalClassName={`${styles.sign_in_btn}`}
                        onClick={() => {
                          setType('Forgotpassword')
                        }}
                      >
                        Reset
                      </VmsButton>
                    </div>
                    <div className={styles.buttoncontainer}>
                      <VmsButton
                        additionalClassName={`${styles.sign_in_btn}`}
                        onClick={() => {
                          cf.redirectTo('/login')
                          setType('Signin')
                        }}
                      >
                        Back to login
                      </VmsButton>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )

      case 'ResetPasswordSuccess':
        return (
          <>
            <div className={styles.login__form}>
              <div className={styles.login__form_container}>
                <header className={styles.login__form_header}>
                  <div
                    className={styles.login__logo}
                    onClick={() => {
                      redirectToLogin()
                    }}
                  >
                    <img src={imgLogo} alt="logo" className={styles.login__logo_image} />
                  </div>
                </header>
                <div className={styles.login__form_content}>
                  <div className={styles.password_reset__container}>
                    <div className={styles.password_reset__header}>
                      <div className={styles.password_reset__icon_wrapper}>
                        <span className={styles.confirmed_icon}>
                          <svg
                            width="49"
                            height="49"
                            viewBox="0 0 49 49"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21.8699 33.7L35.9699 19.6L33.1699 16.8L21.8699 28.1L16.1699 22.4L13.3699 25.2L21.8699 33.7ZM24.6699 44.5C21.9033 44.5 19.3033 43.975 16.8699 42.925C14.4366 41.875 12.3199 40.45 10.5199 38.65C8.71992 36.85 7.29492 34.7333 6.24492 32.3C5.19492 29.8667 4.66992 27.2667 4.66992 24.5C4.66992 21.7333 5.19492 19.1333 6.24492 16.7C7.29492 14.2667 8.71992 12.15 10.5199 10.35C12.3199 8.55 14.4366 7.125 16.8699 6.075C19.3033 5.025 21.9033 4.5 24.6699 4.5C27.4366 4.5 30.0366 5.025 32.4699 6.075C34.9033 7.125 37.0199 8.55 38.8199 10.35C40.6199 12.15 42.0449 14.2667 43.0949 16.7C44.1449 19.1333 44.6699 21.7333 44.6699 24.5C44.6699 27.2667 44.1449 29.8667 43.0949 32.3C42.0449 34.7333 40.6199 36.85 38.8199 38.65C37.0199 40.45 34.9033 41.875 32.4699 42.925C30.0366 43.975 27.4366 44.5 24.6699 44.5ZM24.6699 40.5C29.1366 40.5 32.9199 38.95 36.0199 35.85C39.1199 32.75 40.6699 28.9667 40.6699 24.5C40.6699 20.0333 39.1199 16.25 36.0199 13.15C32.9199 10.05 29.1366 8.5 24.6699 8.5C20.2033 8.5 16.4199 10.05 13.3199 13.15C10.2199 16.25 8.66992 20.0333 8.66992 24.5C8.66992 28.9667 10.2199 32.75 13.3199 35.85C16.4199 38.95 20.2033 40.5 24.6699 40.5Z"
                              fill="#43A047"
                            />
                          </svg>
                        </span>
                      </div>
                      <div className={styles.password_reset__content}>
                        <h1 className={styles.password_reset__title}>Password Reset Confirmed</h1>
                        <p className={styles.password_reset__description}>
                          Your password has been successfully changed, and a confirmation email has
                          been sent to you.
                        </p>
                      </div>
                    </div>

                    <div className={styles.password_reset__divider}></div>
                    <div className={styles.buttoncontainer}>
                      <VmsButton
                        additionalClassName={`${isMatch ? '' : styles.reset_button_disable}`}
                        isLoading={onClickLoginLoader}
                        onClick={() => {
                          cf.redirectTo('/login')
                          setType('Signin')
                        }}
                      >
                        Login now
                      </VmsButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )

      case 'ForgotAgencyUserName':
        return (
          <div className={`${styles.forgot_agency__form} custom_scroll`}>
            <div className={`${styles.forgot_agency__form_container} ${styles.flexUnset}`}>
              <header className={styles.login__form_header}>
                <div
                  className={styles.login__logo}
                  onClick={() => {
                    redirectToLogin()
                  }}
                >
                  <img src={imgLogo} alt="logo" className={styles.login__logo_image} />
                </div>
              </header>
              <div className={styles.forgot_agency__form_content}>
                <div className={styles.forgot_agency__form_title_wrapper}>
                  <h2 className={styles.forgot_agency__form_title}>
                    Forgot Agency Code or Username
                  </h2>
                  <div className={styles.forgot_agency__form_subheading_wrapper}>
                    {/* <p className={styles.forgot_agency__form_subheading}>Dear Support Team,</p> */}
                    {/* <p className={styles.forgot_agency__form_subheading}>
                      We are unable to retrieve our Agency Code or Username and would appreciate
                      your assistance in recovering it.
                    </p> */}
                    <p className={styles.forgot_agency__form_subheading}>
                      Forgot your Agency Code or Username? Please fill out this form for assistance.
                    </p>
                  </div>
                </div>

                <div
                  className={`${styles.forgot_agency__form_content_flex} ${styles.margin_bottom_no}`}
                >
                  <div className={styles.forgot_agency__form_content_left}>
                    <h4 className={styles.forgot_agency__form_content_subtitle}>
                      Sender's Details
                    </h4>
                  </div>
                  <div className={styles.forgot_agency__form_content_right}>
                    <h4
                      className={`${styles.forgot_agency__form_content_subtitle} ${styles.text_align}`}
                    >
                      <span className={styles.star_icon}>*</span> Mandatory Fields
                    </h4>
                  </div>
                </div>

                <div className={styles.forgot_agency__form_content_flex}>
                  <div className={styles.forgot_agency__form_content_left}>
                    <div className={`${styles.input_container} ${styles.form_input_container}`}>
                      <label>
                        <VmsInputText
                          value={formData.senderName}
                          id="senderName"
                          type={'text'}
                          placeholder="Name of Sender *"
                          secondPlaceHolder="senderName"
                          onChange={(e) => handleChange(e.target?.value, 'senderName')}
                        />
                      </label>
                      {errors.senderName && (
                        <div className={styles.login_errors}>{errors.senderName}</div>
                      )}
                    </div>
                  </div>
                  <div className={styles.forgot_agency__form_content_right}>
                    <div className={`${styles.input_container} ${styles.form_input_container}`}>
                      <label>
                        <VmsInputText
                          value={formData.senderEmail}
                          id="senderEmail"
                          type={'text'}
                          placeholder="Sender Email ID *"
                          secondPlaceHolder="senderEmail"
                          onChange={(e) => handleChange(e.target?.value, 'senderEmail')}
                        />
                      </label>
                      {errors.senderEmail && (
                        <div className={styles.login_errors}>{errors.senderEmail}</div>
                      )}
                    </div>
                  </div>
                </div>

                <h4 className={styles.forgot_agency__form_content_subtitle}>Agency Details</h4>

                <div className={styles.forgot_agency__form_content_flex}>
                  <div className={styles.forgot_agency__form_content_left}>
                    <div className={`${styles.input_container} ${styles.form_input_container}`}>
                      <VmsInputText
                        value={formData.agencyName}
                        id="agencyName"
                        type={'text'}
                        placeholder="Agency Name *"
                        secondPlaceHolder="agencyName"
                        onChange={(e) => handleChange(e.target?.value, 'agencyName')}
                      />
                      {errors.agencyName && (
                        <div className={styles.login_errors}>{errors.agencyName}</div>
                      )}
                    </div>
                  </div>
                  <div className={styles.forgot_agency__form_content_right}>
                    <div className={`${styles.input_container} ${styles.form_input_container}`}>
                      <VmsInputText
                        value={formData.agencyEmail}
                        id="agencyEmail"
                        type={'text'}
                        placeholder="Agency Email ID *"
                        secondPlaceHolder="agencyEmail"
                        onChange={(e) => handleChange(e.target?.value, 'agencyEmail')}
                      />
                      {errors.agencyEmail && (
                        <div className={styles.login_errors}>{errors.agencyEmail}</div>
                      )}
                    </div>
                  </div>
                </div>

                <div className={styles.forgot_agency__form_content_flex}>
                  <div className={styles.forgot_agency__form_content_left}>
                    <div className={`${styles.input_container} ${styles.form_input_container}`}>
                      <VmsInputText
                        value={formData.contactPersonName}
                        id="contactPersonName"
                        type={'text'}
                        placeholder="Contact Person Name *"
                        secondPlaceHolder="contactPersonName"
                        onChange={(e) => handleChange(e.target?.value, 'contactPersonName')}
                      />
                      {errors.contactPersonName && (
                        <div className={styles.login_errors}>{errors.contactPersonName}</div>
                      )}
                    </div>
                  </div>
                  <div className={styles.forgot_agency__form_content_right}>
                    <div
                      className={`${styles.input_container} ${styles.form_input_container} ${styles.input_container_ISD}`}
                    >
                      <VmsMobileInputText
                        id="phoneNumber"
                        placeholder={'Contact Number.. *'}
                        // inputlabel={'ISD Code*'}
                        rightView={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="8"
                            height="6"
                            viewBox="0 0 8 6"
                            fill="none"
                          >
                            <path
                              d="M7.82275 0.694164C7.57475 0.426164 7.17275 0.426164 6.92475 0.694164L4.00475 3.84916L1.08575 0.696164C0.83775 0.428164 0.43475 0.428164 0.18675 0.696164C-0.06225 0.964164 -0.06225 1.39916 0.18675 1.66816L3.55275 5.30516C3.73975 5.50716 4.01175 5.55816 4.24175 5.45616C4.31975 5.42316 4.39375 5.37316 4.45675 5.30516L7.82275 1.66716C8.07075 1.39816 8.07075 0.963164 7.82275 0.694164Z"
                              fill="#4B4B4B"
                            />
                          </svg>
                        }
                        className={styles.contryno}
                        selectedValue={`+91`}
                        selectedIndex={'+91'}
                        defaultValue={'+91'}
                        selectedValueFilterBy={'label'}
                        value={formData.contactNumber}
                        mobileNumber={formData.contactNumber}
                        // onChange={(e) => onChangeSignMobile(e.target.value, 'contactNumber')}
                        onChange={(e) => {
                          if (mobileNumberZeroRegex.test(e.target.value) || e.target.value == '') {
                            onChangeSignMobile(e.target.value, 'contactNumber')
                          }
                        }}
                        // onMobileNumberChange={(e) => onChangeSignMobile(e, 'contactNumber')}
                        onMobileNumberChange={(e) => {
                          if (mobileNumberZeroRegex.test(e) || e == '') {
                            onChangeSignMobile(e, 'contactNumber')
                          }
                        }}
                        // onCountryChange={(e) => onCountryInputSelectClick({target: {id: 'countryISD', value: e }})}
                        onCountryChange={(val, item) => handleIsdSelect(val, item, 'isdCode')}
                        onCountryCodeSelect={(val, item) => handleIsdSelect(val, item, 'isdCode')}
                        // onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                        maxLength={'16'}
                      />
                      {errors.contactNumber && (
                        <div className={styles.login_errors}>{errors.contactNumber}</div>
                      )}
                    </div>
                  </div>
                </div>

                <div className={styles.forgot_agency__form_content_flex}>
                  <div className={styles.forgot_agency__form_content_left}>
                    <div className={`${styles.input_container} ${styles.form_input_container}`}>
                      <Dropdown
                        holiday="login"
                        additionalClassName={styles.dropdown_search}
                        options={originCountries}
                        variant="searchWithoutCheckboxWithCode"
                        placeholder="Country*"
                        label="Country*"
                        value={countryName}
                        onChange={(value) => handleSelectionChange(value, 'country')}
                        uniqueKey={'agencyCountry'}
                        isMultiSelect={false}
                        showDropdownIcon={true}
                        showCrossIcon={false}
                        customDropdownIcon={
                          <svg
                            width="12"
                            height="7"
                            viewBox="0 0 12 7"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.18892 0.540437L0.172852 1.51184L5.91334 7L11.6538 1.51184L10.6378 0.540437L5.91334 5.05719L1.18892 0.540437Z"
                              fill="#555555"
                            />
                          </svg>
                        }
                        withInput={true}
                        isMobile={false}
                        header={'Select Country'}
                        modalCrossIcon={
                          <svg
                            width="30"
                            height="31"
                            viewBox="0 0 30 31"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect y="0.5" width="30" height="30" rx="15" fill="#E5E7EB" />
                            <path
                              d="M20.4838 8.6424L15 14.1262L9.51616 8.6424C9.32629 8.45253 9.0189 8.45253 8.82952 8.6424L8.1424 9.32952C7.95253 9.51939 7.95253 9.82677 8.1424 10.0162L13.6262 15.5L8.1424 20.9838C7.95253 21.1737 7.95253 21.4811 8.1424 21.6705L8.82952 22.3576C9.01939 22.5475 9.32677 22.5475 9.51616 22.3576L15 16.8738L20.4838 22.3576C20.6737 22.5475 20.9811 22.5475 21.1705 22.3576L21.8576 21.6705C22.0475 21.4806 22.0475 21.1732 21.8576 20.9838L16.3738 15.5L21.8576 10.0162C22.0475 9.82629 22.0475 9.5189 21.8576 9.32952L21.1705 8.6424C20.9806 8.45253 20.6732 8.45253 20.4838 8.6424Z"
                              fill="#555555"
                            />
                          </svg>
                        }
                      />
                      {errors.country && (
                        <div className={styles.login_errors}>{errors.country}</div>
                      )}
                    </div>
                  </div>
                  <div className={styles.forgot_agency__form_content_right}></div>
                </div>

                <div className={styles.forgot_agency__form_content_flex}>
                  <div className={styles.forgot_agency__form_content_left}>
                    <div className={`${styles.input_container} ${styles.form_input_container}`}>
                      <VmsInputText
                        value={formData.agencyCode}
                        id="agencyCode"
                        type={'text'}
                        placeholder="Agency Code"
                        secondPlaceHolder="agencyCode"
                        onChange={(e) => handleChange(e.target?.value, 'agencyCode')}
                        maxLength={'10'}
                        minLength={'3'}
                      />
                    </div>
                    {errors.agencyCode && (
                      <div className={styles.login_errors}>{errors.agencyCode}</div>
                    )}
                  </div>
                  <div className={styles.forgot_agency__form_content_right}>
                    <div className={`${styles.input_container} ${styles.form_input_container}`}>
                      <VmsInputText
                        value={formData.username}
                        id="username"
                        type={'text'}
                        placeholder="Username"
                        secondPlaceHolder="Username"
                        onChange={(e) => handleChange(e.target?.value, 'username')}
                        maxLength={'10'}
                        minLength={3}
                      />
                    </div>
                    {errors.username && (
                      <div className={styles.login_errors}>{errors.username}</div>
                    )}
                  </div>
                </div>

                <div className={styles.forgot_agency__form_content_flex}>
                  <div
                    className={`${styles.input_container} ${styles.fogot_agency_input_container}`}
                  >
                    <textarea
                      resize="none"
                      name="remarks"
                      value={formData.remarks}
                      placeholder="Remarks *"
                      onChange={(e) => handleChange(e.target?.value, 'remarks')}
                      maxLength="500"
                    />
                    {errors.remarks && <div className={styles.login_errors}>{errors.remarks}</div>}
                  </div>
                </div>
                <div className={styles.remarksCounter}>{formData.remarks?.length}/500</div>
                <div className={styles.buttoncontainer}>
                  {props.home?.data?.site?.login_captcha_key !== '' &&
                    props.home?.data?.site?.login_captcha_key !== undefined && (
                      <CaptchaComponent
                        setCaptchDataCallback={setCaptchDataCallBack}
                        siteData={props.home?.data}
                        test="test"
                      />
                    )}
                  {captchStates.captchErrorMsg !== '' ? (
                    <div className={styles.login_errors}>{captchStates.captchErrorMsg}</div>
                  ) : (
                    ''
                  )}
                  <VmsButton
                    //  additionalClassName={`${isMatch ?"":styles.reset_button_disable}`}
                    isLoading={onClickLoginLoader}
                    onClick={handleSubmit}
                  >
                    Submit
                  </VmsButton>
                  <VmsButton
                    additionalClassName={styles.back_to_login}
                    onClick={() => {
                      handleBackToLogin()
                    }}
                  >
                    Back to login
                  </VmsButton>
                </div>
              </div>
            </div>
          </div>
        )

      case 'RegisterAgency':
        return (
          <>
            <div className={`${styles.forgot_agency__form} custom_scroll`}>
              <div className={styles.forgot_agency__form_container}>
                <header className={styles.login__form_header}>
                  <div
                    className={styles.login__logo}
                    onClick={() => {
                      redirectToLogin()
                    }}
                  >
                    <img src={imgLogo} alt="logo" className={styles.login__logo_image} />
                  </div>
                </header>
                <div className={styles.forgot_agency__form_content}>
                  <div className={styles.forgot_agency__form_title_wrapper}>
                    <h2 className={styles.forgot_agency__form_title}>
                      Get Started with Registration
                    </h2>
                    <div className={styles.forgot_agency__form_subheading_wrapper}>
                      {!isMobile && (
                        <>
                          <p className={styles.forgot_agency__form_subheading}>
                            Please provide your information below to register.
                          </p>
                          <p className={styles.forgot_agency__form_subheading}>
                            It only takes a minute to sign up, and you&apos;ll be ready to explore
                            everything we offer.
                          </p>
                        </>
                      )}

                      {isMobile && (
                        <>
                          <p className={styles.forgot_agency__form_subheading}>
                            Please provide your information below to register. It only takes a
                            minute to sign up, and you'll be ready to explore everything we
                            offer.
                          </p>
                        </>
                      )}
                    </div>
                  </div>

                  <div
                    className={`${styles.forgot_agency__form_content_flex} ${styles.margin_bottom_no}`}
                  >
                    <div className={styles.forgot_agency__form_content_left}>
                      <h4 className={styles.forgot_agency__form_content_subtitle}>
                        Agency Details
                      </h4>
                    </div>
                    <div className={styles.forgot_agency__form_content_right}>
                      <h4
                        className={`${styles.forgot_agency__form_content_subtitle} ${styles.text_align}`}
                      >
                        <span className={styles.star_icon}>*</span> Mandatory Fields
                      </h4>
                    </div>
                  </div>

                  <div className={styles.forgot_agency__form_content_flex}>
                    <div className={styles.forgot_agency__form_content_left}>
                      <div className={`${styles.input_container} ${styles.form_input_container}`}>
                        <VmsInputText
                          id="agencyName"
                          value={registerForm.agencyName}
                          label={'Agency Name'}
                          placeholder={`Agency Name *`}
                          additionalClassName={CSS?.first_name_Add}
                          onChange={(e) => onChangeRegister(e, 'agencyName')}
                        />
                        {registerFormErr.agencyName && (
                          <div className={styles.login_errors}>{registerFormErr.agencyName}</div>
                        )}
                      </div>
                    </div>
                    <div className={styles.forgot_agency__form_content_right}>
                      <div className={`${styles.input_container} ${styles.form_input_container}`}>
                        <Dropdown
                          holiday="login"
                          additionalClassName={styles['dropdown-search']}
                          options={originCountries}
                          variant="searchWithoutCheckboxWithCode"
                          placeholder="Country*"
                          label="Country*"
                          onChange={(value) => handleSelectionChange(value, 'agencyCountry')}
                          uniqueKey={'agencyCountry'}
                          isMultiSelect={false}
                          showDropdownIcon={true}
                          showCrossIcon={false}
                          customDropdownIcon={
                            <svg
                              width="12"
                              height="7"
                              viewBox="0 0 12 7"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1.18892 0.540437L0.172852 1.51184L5.91334 7L11.6538 1.51184L10.6378 0.540437L5.91334 5.05719L1.18892 0.540437Z"
                                fill="#555555"
                              />
                            </svg>
                          }
                          withInput={true}
                          isMobile={false}
                          header={'Select Country'}
                          modalCrossIcon={
                            <svg
                              width="30"
                              height="31"
                              viewBox="0 0 30 31"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect y="0.5" width="30" height="30" rx="15" fill="#E5E7EB" />
                              <path
                                d="M20.4838 8.6424L15 14.1262L9.51616 8.6424C9.32629 8.45253 9.0189 8.45253 8.82952 8.6424L8.1424 9.32952C7.95253 9.51939 7.95253 9.82677 8.1424 10.0162L13.6262 15.5L8.1424 20.9838C7.95253 21.1737 7.95253 21.4811 8.1424 21.6705L8.82952 22.3576C9.01939 22.5475 9.32677 22.5475 9.51616 22.3576L15 16.8738L20.4838 22.3576C20.6737 22.5475 20.9811 22.5475 21.1705 22.3576L21.8576 21.6705C22.0475 21.4806 22.0475 21.1732 21.8576 20.9838L16.3738 15.5L21.8576 10.0162C22.0475 9.82629 22.0475 9.5189 21.8576 9.32952L21.1705 8.6424C20.9806 8.45253 20.6732 8.45253 20.4838 8.6424Z"
                                fill="#555555"
                              />
                            </svg>
                          }
                          value={registerForm.agencyCountry}
                        />
                        {registerFormErr.agencyCountry && (
                          <div className={styles.login_errors}>{registerFormErr.agencyCountry}</div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className={styles.forgot_agency__form_content_flex}>
                    <div className={styles.forgot_agency__form_content_left}>
                      <div className={`${styles.input_container} ${styles.form_input_container}`}>
                        <Dropdown
                          holiday="login"
                          additionalClassName={styles['dropdown-search']}
                          options={StateListData}
                          variant="searchWithoutCheckboxWithCode"
                          placeholder="State*"
                          label="State*"
                          onChange={(value) => handleSelectionChange(value, 'agencyState')}
                          uniqueKey={'agencyState'}
                          isMultiSelect={false}
                          showDropdownIcon={true}
                          showCrossIcon={false}
                          customDropdownIcon={
                            <svg
                              width="12"
                              height="7"
                              viewBox="0 0 12 7"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1.18892 0.540437L0.172852 1.51184L5.91334 7L11.6538 1.51184L10.6378 0.540437L5.91334 5.05719L1.18892 0.540437Z"
                                fill="#555555"
                              />
                            </svg>
                          }
                          withInput={true}
                          isMobile={false}
                          header={'Select Country'}
                          modalCrossIcon={
                            <svg
                              width="30"
                              height="31"
                              viewBox="0 0 30 31"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect y="0.5" width="30" height="30" rx="15" fill="#E5E7EB" />
                              <path
                                d="M20.4838 8.6424L15 14.1262L9.51616 8.6424C9.32629 8.45253 9.0189 8.45253 8.82952 8.6424L8.1424 9.32952C7.95253 9.51939 7.95253 9.82677 8.1424 10.0162L13.6262 15.5L8.1424 20.9838C7.95253 21.1737 7.95253 21.4811 8.1424 21.6705L8.82952 22.3576C9.01939 22.5475 9.32677 22.5475 9.51616 22.3576L15 16.8738L20.4838 22.3576C20.6737 22.5475 20.9811 22.5475 21.1705 22.3576L21.8576 21.6705C22.0475 21.4806 22.0475 21.1732 21.8576 20.9838L16.3738 15.5L21.8576 10.0162C22.0475 9.82629 22.0475 9.5189 21.8576 9.32952L21.1705 8.6424C20.9806 8.45253 20.6732 8.45253 20.4838 8.6424Z"
                                fill="#555555"
                              />
                            </svg>
                          }
                          value={registerForm.agencyState}
                        />
                        {registerFormErr.agencyState && (
                          <div className={styles.login_errors}>{registerFormErr.agencyState}</div>
                        )}
                      </div>
                    </div>
                    <div className={styles.forgot_agency__form_content_right}>
                      <div className={`${styles.input_container} ${styles.form_input_container}`}>
                        <Dropdown
                          holiday="login"
                          additionalClassName={styles['dropdown-search']}
                          options={CityListData}
                          variant="searchWithoutCheckboxWithCode"
                          placeholder="City*"
                          label="City*"
                          onChange={(value) => handleSelectionChange(value, 'agencyCity')}
                          uniqueKey={'agencyCity'}
                          isMultiSelect={false}
                          showDropdownIcon={true}
                          showCrossIcon={false}
                          customDropdownIcon={
                            <svg
                              width="12"
                              height="7"
                              viewBox="0 0 12 7"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1.18892 0.540437L0.172852 1.51184L5.91334 7L11.6538 1.51184L10.6378 0.540437L5.91334 5.05719L1.18892 0.540437Z"
                                fill="#555555"
                              />
                            </svg>
                          }
                          withInput={true}
                          isMobile={false}
                          header={'Select Country'}
                          modalCrossIcon={
                            <svg
                              width="30"
                              height="31"
                              viewBox="0 0 30 31"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect y="0.5" width="30" height="30" rx="15" fill="#E5E7EB" />
                              <path
                                d="M20.4838 8.6424L15 14.1262L9.51616 8.6424C9.32629 8.45253 9.0189 8.45253 8.82952 8.6424L8.1424 9.32952C7.95253 9.51939 7.95253 9.82677 8.1424 10.0162L13.6262 15.5L8.1424 20.9838C7.95253 21.1737 7.95253 21.4811 8.1424 21.6705L8.82952 22.3576C9.01939 22.5475 9.32677 22.5475 9.51616 22.3576L15 16.8738L20.4838 22.3576C20.6737 22.5475 20.9811 22.5475 21.1705 22.3576L21.8576 21.6705C22.0475 21.4806 22.0475 21.1732 21.8576 20.9838L16.3738 15.5L21.8576 10.0162C22.0475 9.82629 22.0475 9.5189 21.8576 9.32952L21.1705 8.6424C20.9806 8.45253 20.6732 8.45253 20.4838 8.6424Z"
                                fill="#555555"
                              />
                            </svg>
                          }
                          value={registerForm.agencyCity}
                        />
                        {registerFormErr.agencyCity && (
                          <div className={styles.login_errors}>{registerFormErr.agencyCity}</div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className={styles.forgot_agency__form_content_flex}>
                    <div className={styles.forgot_agency__form_content_left}>
                      <div className={`${styles.input_container} ${styles.form_input_container}`}>
                        <VmsInputText
                          id="agencyAddress"
                          value={registerForm.agencyAddress}
                          label={'Address'}
                          placeholder={`Street Address`}
                          additionalClassName={CSS?.first_name_Add}
                          onChange={(e) => onChangeRegister(e, 'agencyAddress')}
                        />
                      </div>
                    </div>
                    <div className={styles.forgot_agency__form_content_right}>
                      {/* Pin / Zip Code */}
                      <div className={`${styles.input_container} ${styles.form_input_container}`}>
                        <VmsInputText
                          id="agencyPincode"
                          value={registerForm.agencyPincode}
                          label={'Pin / Zip Code'}
                          placeholder={`Pin / Zip Code`}
                          additionalClassName={CSS?.first_name_Add}
                          onChange={(e) => onChangeRegister(e, 'agencyPincode')}
                          maxLength={'6'}
                        />
                        {/* {registerFormErr.agencyPincode && (
                              <div className={styles.login_errors}>{registerFormErr.agencyPincode}</div>
                            )} */}
                      </div>
                    </div>
                  </div>

                  <div className={styles.forgot_agency__form_content_flex}>
                    <div className={styles.forgot_agency__form_content_left}>
                      <div className={`${styles.input_container} ${styles.form_input_container}`}>
                        <VmsInputText
                          id="busAgencyEmail"
                          value={registerForm.busAgencyEmail}
                          label={'Business Email ID'}
                          placeholder={`Business Email ID *`}
                          additionalClassName={CSS?.first_name_Add}
                          onChange={(e) => onChangeRegister(e, 'busAgencyEmail')}
                        />
                        {registerFormErr.busAgencyEmail && (
                          <div className={styles.login_errors}>
                            {registerFormErr.busAgencyEmail}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={styles.forgot_agency__form_content_right}>
                      <div
                        className={`${styles.input_container} ${styles.form_input_container} ${styles.input_container_ISD} ${styles.input_container_ISD_error}`}
                      >
                        <VmsMobileInputText
                          id="busContactNumber"
                          placeholder={'Business Contact Number *'}
                          inputlabel={'ISD Code'}
                          rightView={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8"
                              height="6"
                              viewBox="0 0 8 6"
                              fill="none"
                            >
                              <path
                                d="M7.82275 0.694164C7.57475 0.426164 7.17275 0.426164 6.92475 0.694164L4.00475 3.84916L1.08575 0.696164C0.83775 0.428164 0.43475 0.428164 0.18675 0.696164C-0.06225 0.964164 -0.06225 1.39916 0.18675 1.66816L3.55275 5.30516C3.73975 5.50716 4.01175 5.55816 4.24175 5.45616C4.31975 5.42316 4.39375 5.37316 4.45675 5.30516L7.82275 1.66716C8.07075 1.39816 8.07075 0.963164 7.82275 0.694164Z"
                                fill="#4B4B4B"
                              />
                            </svg>
                          }
                          className={styles.contryno}
                          selectedValue={`+91`}
                          selectedIndex={'+91'}
                          defaultValue={'+91'}
                          selectedValueFilterBy={'label'}
                          value={registerForm.busContactNumber}
                          mobileNumber={registerForm.busContactNumber}
                          onChange={(e) => {
                            if (
                              mobileNumberZeroRegex.test(e.target.value) ||
                              e.target.value == ''
                            ) {
                              onChangeSignMobile(e.target.value, 'busContactNumber')
                            }
                          }}
                          onMobileNumberChange={(e) => {
                            if (mobileNumberZeroRegex.test(e) || e == '') {
                              onChangeSignMobile(e, 'busContactNumber')
                            }
                          }}
                          // onCountryChange={(e) => onCountryInputSelectClick({target: {id: 'countryISD', value: e }})}
                          onCountryChange={(val, item) => handleIsdSelect(val, item, 'busIsdCode')}
                          onCountryCodeSelect={(val, item) =>
                            handleIsdSelect(val, item, 'busIsdCode')
                          }
                          // onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                          maxLength={'16'}
                        />
                        {registerFormErr.busContactNumber && (
                          <div className={styles.login_errors}>
                            {registerFormErr.busContactNumber}
                          </div>
                        )}
                        {registerFormErr.busIsdCode && (
                          <div className={styles.login_errors}>{registerFormErr.busIsdCode}</div>
                        )}
                      </div>
                    </div>
                  </div>

                  <h4 className={styles.forgot_agency__form_content_subtitle_heading}>
                    Administrator Details
                  </h4>

                  <div className={styles.forgot_agency__form_content_flex}>
                    <div className={styles.forgot_agency__form_content_left}>
                      {/* First Name */}
                      <div
                        className={`${styles.input_container} ${styles.form_input_container} ${styles.input_container_title}`}
                      >
                        <div className={styles.title_dropdown_flex}>
                          <div className={styles.dropdown_main_flex}>
                            <VmsAutocompleteDropdown
                              additionalClassName="custom_scroll registeration_title"
                              autoHighlight
                              items={TitleList}
                              onSelect={(val, item) => onChangeTitle(val, item, 'admTitle')}
                              value={registerForm?.admTitle}
                              isDropdown={true}
                              placeholder="Title *"
                              secondPlaceHolder={registerForm?.admTitle ? '' : 'Title'}
                            />
                            <span
                              onClick={() =>
                                document.querySelector('.registeration_title input')?.focus()
                              }
                              className={styles.dropdown_icon}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="7"
                                viewBox="0 0 12 7"
                                fill="none"
                              >
                                <path
                                  d="M0.990832 0.270234L6.67546e-08 1.24164L5.59792 6.7298L11.1958 1.24164L10.205 0.270234L5.59792 4.78699L0.990832 0.270234Z"
                                  fill="#4E4E4E"
                                />
                              </svg>
                            </span>
                          </div>
                          <VmsInputText
                            value={registerForm.admfirstName}
                            id="admfirstName"
                            type={'text'}
                            placeholder="First Name *"
                            secondPlaceHolder="admfirstName"
                            onChange={(e) => onChangeRegister(e, 'admfirstName')}
                          />
                        </div>
                        {registerFormErr?.admTitle && (
                          <div className={styles.login_errors}>{registerFormErr.admTitle}</div>
                        )}
                        {registerFormErr.admfirstName && (
                          <div className={styles.login_errors}>{registerFormErr.admfirstName}</div>
                        )}
                      </div>
                    </div>
                    <div className={styles.forgot_agency__form_content_right}>
                      <div className={`${styles.input_container} ${styles.form_input_container}`}>
                        <VmsInputText
                          value={registerForm.admLastName}
                          id="admLastName"
                          type={'text'}
                          placeholder="Last Name *"
                          secondPlaceHolder="admLastName"
                          onChange={(e) => onChangeRegister(e, 'admLastName')}
                        />
                        {registerFormErr.admLastName && (
                          <div className={styles.login_errors}>{registerFormErr.admLastName}</div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className={styles.forgot_agency__form_content_flex}>
                    <div className={styles.forgot_agency__form_content_left}>
                      <div className={`${styles.input_container} ${styles.form_input_container}`}>
                        <VmsInputText
                          id="adminEmail"
                          value={registerForm.adminEmail}
                          label={'Admin Email ID'}
                          placeholder={`Admin Email ID *`}
                          additionalClassName={CSS?.first_name_Add}
                          onChange={(e) => onChangeRegister(e, 'adminEmail')}
                        />
                        {registerFormErr.adminEmail && (
                          <div className={styles.login_errors}>{registerFormErr.adminEmail}</div>
                        )}
                      </div>
                    </div>
                    <div className={styles.forgot_agency__form_content_right}>
                      <div
                        className={`${styles.input_container} ${styles.form_input_container} ${styles.input_container_ISD} ${styles.input_container_ISD_error}`}
                      >
                        <VmsMobileInputText
                          id="admContactNumber"
                          placeholder={'Admin Mobile number *'}
                          inputlabel={'ISD Code*'}
                          rightView={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8"
                              height="6"
                              viewBox="0 0 8 6"
                              fill="none"
                            >
                              <path
                                d="M7.82275 0.694164C7.57475 0.426164 7.17275 0.426164 6.92475 0.694164L4.00475 3.84916L1.08575 0.696164C0.83775 0.428164 0.43475 0.428164 0.18675 0.696164C-0.06225 0.964164 -0.06225 1.39916 0.18675 1.66816L3.55275 5.30516C3.73975 5.50716 4.01175 5.55816 4.24175 5.45616C4.31975 5.42316 4.39375 5.37316 4.45675 5.30516L7.82275 1.66716C8.07075 1.39816 8.07075 0.963164 7.82275 0.694164Z"
                                fill="#4B4B4B"
                              />
                            </svg>
                          }
                          className={styles.contryno}
                          selectedValue={`+91`}
                          selectedIndex={'+91'}
                          defaultValue={'+91'}
                          selectedValueFilterBy={'label'}
                          value={registerForm.admContactNumber}
                          mobileNumber={registerForm.admContactNumber}
                          // onChange={(e) => onChangeSignMobile(e.target.value, 'admContactNumber')}
                          onChange={(e) => {
                            if (
                              mobileNumberZeroRegex.test(e.target.value) ||
                              e.target.value == ''
                            ) {
                              onChangeSignMobile(e.target.value, 'admContactNumber')
                            }
                          }}
                          // onMobileNumberChange={(e) => onChangeSignMobile(e, 'admContactNumber')}
                          onMobileNumberChange={(e) => {
                            if (mobileNumberZeroRegex.test(e) || e == '') {
                              onChangeSignMobile(e, 'admContactNumber')
                            }
                          }}
                          // onCountryChange={(e) => onCountryInputSelectClick({target: {id: 'countryISD', value: e }})}
                          onCountryChange={(val, item) => {
                            handleIsdSelect(val, item, 'admIsdCode')
                          }}
                          onCountryCodeSelect={(val, item) => {
                            handleIsdSelect(val, item, 'admIsdCode')
                          }}
                          // onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                          maxLength={'16'}
                        />
                        {registerFormErr.admContactNumber && (
                          <div className={styles.login_errors}>
                            {registerFormErr.admContactNumber}
                          </div>
                        )}
                        {registerFormErr.admIsdCode && (
                          <div className={styles.login_errors}>{registerFormErr.admIsdCode}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.buttoncontainer}>
                  {props.home?.data?.site?.login_captcha_key !== '' &&
                    props.home?.data?.site?.login_captcha_key !== undefined && (
                      <CaptchaComponent
                        setCaptchDataCallback={setCaptchDataCallBack}
                        siteData={props.home?.data}
                        test="test"
                      />
                    )}
                  {captchStates.captchErrorMsg !== '' ? (
                    <div className={styles.login_errors}>{captchStates.captchErrorMsg}</div>
                  ) : (
                    ''
                  )}
                  <VmsButton
                    additionalClassName={styles.submit_btn}
                    onClick={onSubmitRegister}
                    isLoading={onClickLoginLoader}
                  >
                    Register Now
                  </VmsButton>
                  <VmsButton
                    additionalClassName={styles.back_to_login}
                    isLoading={onClickLoginLoader}
                    onClick={() => {
                      handleBackToLogin()
                    }}
                  >
                    Back to login
                  </VmsButton>
                </div>
              </div>
            </div>
          </>
        )
      case 'ForgotAgencyUserNameSuccess':
        return (
          <>
            <div className={styles.login__form}>
              <div className={styles.login__form_container}>
                <header className={styles.login__form_header}>
                  <div
                    className={styles.login__logo}
                    onClick={() => {
                      redirectToLogin()
                    }}
                  >
                    <img src={imgLogo} alt="logo" className={styles.login__logo_image} />
                  </div>
                </header>
                <div className={styles.login__form_content}>
                  <div className={styles.password_reset__container}>
                    <div className={styles.password_reset__header}>
                      <div className={styles.password_reset__icon_wrapper}>
                        <span className={styles.confirmed_icon}>
                          <svg
                            width="49"
                            height="49"
                            viewBox="0 0 49 49"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21.8699 33.7L35.9699 19.6L33.1699 16.8L21.8699 28.1L16.1699 22.4L13.3699 25.2L21.8699 33.7ZM24.6699 44.5C21.9033 44.5 19.3033 43.975 16.8699 42.925C14.4366 41.875 12.3199 40.45 10.5199 38.65C8.71992 36.85 7.29492 34.7333 6.24492 32.3C5.19492 29.8667 4.66992 27.2667 4.66992 24.5C4.66992 21.7333 5.19492 19.1333 6.24492 16.7C7.29492 14.2667 8.71992 12.15 10.5199 10.35C12.3199 8.55 14.4366 7.125 16.8699 6.075C19.3033 5.025 21.9033 4.5 24.6699 4.5C27.4366 4.5 30.0366 5.025 32.4699 6.075C34.9033 7.125 37.0199 8.55 38.8199 10.35C40.6199 12.15 42.0449 14.2667 43.0949 16.7C44.1449 19.1333 44.6699 21.7333 44.6699 24.5C44.6699 27.2667 44.1449 29.8667 43.0949 32.3C42.0449 34.7333 40.6199 36.85 38.8199 38.65C37.0199 40.45 34.9033 41.875 32.4699 42.925C30.0366 43.975 27.4366 44.5 24.6699 44.5ZM24.6699 40.5C29.1366 40.5 32.9199 38.95 36.0199 35.85C39.1199 32.75 40.6699 28.9667 40.6699 24.5C40.6699 20.0333 39.1199 16.25 36.0199 13.15C32.9199 10.05 29.1366 8.5 24.6699 8.5C20.2033 8.5 16.4199 10.05 13.3199 13.15C10.2199 16.25 8.66992 20.0333 8.66992 24.5C8.66992 28.9667 10.2199 32.75 13.3199 35.85C16.4199 38.95 20.2033 40.5 24.6699 40.5Z"
                              fill="#43A047"
                            />
                          </svg>
                        </span>
                      </div>
                      <div className={styles.password_reset__content}>
                        <h1 className={styles.password_reset__title}>Request Confirmed</h1>
                        <p className={styles.password_reset__description}>
                          Your email has been successfully sent to the Support Team. They will reach
                          out to you shortly.{' '}
                        </p>
                      </div>
                    </div>

                    <div className={styles.password_reset__divider}></div>
                    <div className={styles.buttoncontainer}>
                      <VmsButton
                        additionalClassName={`${isMatch ? '' : styles.reset_button_disable} ${styles.back_to_login}`}
                        isLoading={onClickLoginLoader}
                        onClick={() => {
                          handleBackToLogin()
                        }}
                      >
                        Back to login
                      </VmsButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )
      case 'RegisterSuccess':
        return (
          <>
            <div className={styles.login__form}>
              <div className={styles.login__form_container}>
                <header className={styles.login__form_header}>
                  <div
                    className={styles.login__logo}
                    onClick={() => {
                      redirectToLogin()
                    }}
                  >
                    <img src={imgLogo} alt="logo" className={styles.login__logo_image} />
                  </div>
                </header>
                <div className={styles.login__form_content}>
                  <div className={styles.password_reset__container}>
                    <div className={styles.password_reset__header}>
                      <div className={styles.password_reset__icon_wrapper}>
                        <span className={styles.confirmed_icon}>
                          <svg
                            width="49"
                            height="49"
                            viewBox="0 0 49 49"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21.8699 33.7L35.9699 19.6L33.1699 16.8L21.8699 28.1L16.1699 22.4L13.3699 25.2L21.8699 33.7ZM24.6699 44.5C21.9033 44.5 19.3033 43.975 16.8699 42.925C14.4366 41.875 12.3199 40.45 10.5199 38.65C8.71992 36.85 7.29492 34.7333 6.24492 32.3C5.19492 29.8667 4.66992 27.2667 4.66992 24.5C4.66992 21.7333 5.19492 19.1333 6.24492 16.7C7.29492 14.2667 8.71992 12.15 10.5199 10.35C12.3199 8.55 14.4366 7.125 16.8699 6.075C19.3033 5.025 21.9033 4.5 24.6699 4.5C27.4366 4.5 30.0366 5.025 32.4699 6.075C34.9033 7.125 37.0199 8.55 38.8199 10.35C40.6199 12.15 42.0449 14.2667 43.0949 16.7C44.1449 19.1333 44.6699 21.7333 44.6699 24.5C44.6699 27.2667 44.1449 29.8667 43.0949 32.3C42.0449 34.7333 40.6199 36.85 38.8199 38.65C37.0199 40.45 34.9033 41.875 32.4699 42.925C30.0366 43.975 27.4366 44.5 24.6699 44.5ZM24.6699 40.5C29.1366 40.5 32.9199 38.95 36.0199 35.85C39.1199 32.75 40.6699 28.9667 40.6699 24.5C40.6699 20.0333 39.1199 16.25 36.0199 13.15C32.9199 10.05 29.1366 8.5 24.6699 8.5C20.2033 8.5 16.4199 10.05 13.3199 13.15C10.2199 16.25 8.66992 20.0333 8.66992 24.5C8.66992 28.9667 10.2199 32.75 13.3199 35.85C16.4199 38.95 20.2033 40.5 24.6699 40.5Z"
                              fill="#43A047"
                            />
                          </svg>
                        </span>
                      </div>
                      <div className={styles.password_reset__content}>
                        <h1 className={styles.password_reset__title}>
                          Thank you for registering with us!
                        </h1>
                        <p className={styles.password_reset__description}>
                          Your account details have been successfully sent to the Support Team. They
                          will review and activate your account shortly. You will receive a
                          confirmation email with further instructions.{' '}
                        </p>
                      </div>
                    </div>

                    <div className={styles.password_reset__divider}></div>
                    <div className={styles.buttoncontainer}>
                      <VmsButton
                        additionalClassName={`${isMatch ? '' : styles.reset_button_disable} ${styles.back_to_login}`}
                        isLoading={onClickLoginLoader}
                        onClick={() => {
                          handleBackToLogin()
                        }}
                      >
                        Back to login
                      </VmsButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )
      default:
        return null
    }
  }

  return (
    <>
      <div className={styles.loginpage}>
        <section className={styles.login}>
          <div className={styles.login__hero__background__img}>
            <figure className={styles.login__hero__img_wrapper}>
              <img className={styles.login__hero__img} src={imgMain} alt="Background" />
              <figcaption className={styles.login__hero_content}>
                <div className={styles.login__hero_content_info}>
                  <h1 className={styles.login__hero_title}>Power your travel business.</h1>
                  <p className={styles.login__hero_subtitle}>
                    With exclusive rates and real-time bookings.
                  </p>
                </div>
                <nav className={styles.login__nav}>
                  {props?.pageInfo &&
                    props?.pageInfo.data &&
                    props?.pageInfo?.data?.footer &&
                    props?.pageInfo?.data?.footer?.menu &&
                    props?.pageInfo?.data?.footer?.menu.map((fLink, index) => (
                      <>
                        {fLink.active == 'active' ? (
                          <a
                            href={fLink.url}
                            className={styles.login__nav_link}
                            tabIndex="0"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {fLink.text}
                          </a>
                        ) : (
                          ''
                        )}
                      </>
                    ))}
                </nav>
              </figcaption>
            </figure>
          </div>
          <div className={`${styles.login_form__wrapper_container} custom_scroll`}>
            {renderlogin()}
            {type !== 'RegisterAgency' && type !== 'ForgotAgencyUserName' && (
              <div className={styles.copyright_content}>
                <p>
                  {props?.pageInfo?.data?.footer?.text}
                  <span className={styles.one_line_wrapper}>
                    {' '}
                    All Rights Reserved.{' '}
                    <a href="/privacy-policy" target="_blank" className={styles.privacy_policy}>
                      {' '}
                      Privacy Policy
                    </a>
                  </span>
                </p>
              </div>
            )}
          </div>
        </section>
      </div>
    </>
  )
}
